import React, { useState, useContext, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as journeyJson from "../../../static/journeyssr.json"
import {
  uploadDocument,
  finalSubmission,
  fetchAllJourneyData,
  getS3FilenetUpload,
  saveApplication,
  fetchDigilockerDetails,
  getDocuments,
  aesEncryptData,
  retreiveUploadedDocuments,
  s3DownloadDocuments,
  finarkeinGenerateLink,
  finarkeinStatus,
  deleteTempDocument,
  uploadTempDocument,
  getAllTempDocuments,
  moveTempDocumentsToPermanentBucket,
  generateAnurVCLink,
  getConfigByType,
  getDocGrid,
  equitasUnifiedLaunch,
  flexiEdgeProposalForm,
  getAnurPivcStatus,
  finalSubmissionBrowser,
} from "../../services/apiservice"
import pdfIcon from "../../../static/images/ekyc2.png"
import * as lookup from "../../../static/lookup.json"
import { withPrefix } from "gatsby"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { perfiosGenerateLink } from "../../services/perfios-api-service"
import { findCurrentJourneyCode, DataLayerIntegration } from "../services/helperFunctions"
import { errorToastr,successToastr } from "../../services/error-handler"
import { accessToken } from "../../interceptors/jwt-interceptor"
import base64 from 'base-64'
import Select from "react-select"
import { deepCopy } from "../../shared/functions"
import { error } from "toastr"
import ConfirmProceedModal from "./ConfirmProceedModal"
import { triggerSpEnrichment, startSpEnrichmentPolling, verifySpDetailsWithSync } from "../../services/equitasSpDetailsService"
var CryptoJS = require("crypto-js");

const DOCUMENT_UPLOAD_SUPPORT_MESSAGE = "For technical issues related to document upload, please contact IT Service Desk at 0123-4535100 or email itservicedesk@canarahsbclife.in."

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;
  ${props => props.needsDropdown &&
    `
      @media (max-width: 767px) {
        margin: 0px;
      }
    `}
  

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

// Document Grid Configuration - maps document grid codes to doc types and dropdown settings
const docGridConfig = {
  "FINANCIAL_SOW": {
    docType: "_SOW_",
    showDropdown: false,
    uploadDocPurpose: "SOW"
  },
  "SOURCE_OF_WEALTH":{
    docType: "_SOW_",
    showDropdown: false,
    uploadDocPurpose: "SOW"
  },
  "INVESTMENT_PROOF_PR": {
    docType: "_INVPR_",
    showDropdown: false,
    uploadDocPurpose: "_INVPR_"
  },
  "INVESTMENT_PROOF_PROPOSER": {
    docType: "_INVPR_",
    showDropdown: false,
    uploadDocPurpose: "_INVPR_"
  },
  "INCOME_JUSTIFICATION_LA": {
    docType: "_IJL_",
    showDropdown: false,
    uploadDocPurpose: "_IJL_"
  },
  "INCOME_JUSTIFICATION_LIFE_ASSURED": {
    docType: "_IJL_",
    showDropdown: false,
    uploadDocPurpose: "_IJL_"
  },
  "INCOME_PROOF_LA": {
    docType: "_IPL_",
    showDropdown: true,
    uploadDocPurpose: "_IPL_"
  },
  "INCOME_PROOF_LIFE_ASSURED":{
    docType: "_IPL_",
    showDropdown: true,
    uploadDocPurpose: "_IPL_"
  },
  "INCOME_PROOF_PR": {
    docType: "_IPPR_",
    showDropdown: true,
    uploadDocPurpose: "_IPPR_"
  },
  "INCOME_PROOF_PROPOSER":{
    docType: "_IPPR_",
    showDropdown: true,
    uploadDocPurpose: "_IPPR_"
  },
  "INVESTMENT_PROOF_LA": {
    docType: "_INVLA_",
    showDropdown: false,
    uploadDocPurpose: "_INVLA_"
  },
  "INVESTMENT_PROOF_LIFE_ASSURED": {
    docType: "_INVLA_",
    showDropdown: false,
    uploadDocPurpose: "_INVLA_"
  },
  "INCOME_JUSTIFICATION_PR": {
    docType: "_IJPR_",
    showDropdown: false,
    uploadDocPurpose: "_IJPR_"
  },
  "INCOME_JUSTIFICATION_PROPOSER": {
    docType: "_IJPR_",
    showDropdown: false,
    uploadDocPurpose: "_IJPR_"
  }
}

export default function UploadDocuments(props) {
  const [isUploading, setIsUploading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [pivcSubmitError, setPivcSubmitError] = useState("")
  const [isPivcPending, setIsPivcPending] = useState(false)
  const [showSpDetailsModal, setShowSpDetailsModal] = useState(false)
  const [docNumber, setDocNumber] = useState({
    _UID_: {
      count:1
    },
    _PHO_: {
      count: 1
    },
    _IDP_: {
      count: 1
    },
    _SOW_: {
      count: 1
    },
    _CAP_: {
      count: 1
    },
    _PAP_:{
      count: 1
    },
    _AGP_: {
      count: 1
    },
    _OTH_: {
      count: 1
    },
    _CNF_: {
      count: 1
    },
    ADD2: {
      count: 1
    },
    _COC_: {
      count: 1
    },
    _DDI_: {
      count: 1
    },
  })
  const [docNumberProposer, setDocNumberProposer] = useState({
    _PHO_: {
      count: 1
    },
    _IDP_: {
      count: 1
    },
    _CAP_: {
      count: 1
    },
    _PAP_:{
      count: 1
    },
  })
  const [docNumberjointLife, setDocNumberjointLife] = useState({
      _AGP_: {
        count: 1
      },
  })
  const [uploadedDocuments, setUploadedDocuments] = useState({
    _PHO_: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
    _UID_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _IDP_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _SOW_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _CAP_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _PAP_:[{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _AGP_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _OTH_: [{
      path: "",
      name: "",
      location : "",
      msg: "",
    }],
    _CNF_: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
    ADD2: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
    _BDP_: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
    _COC_: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
    _DDI_: {
      path: "",
      name: "",
      location : "",
      msg: "",
    },
  })
  const [responseDocument, setResponseDocument] = useState({
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _UID_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _SOW_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PAP_:[{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _AGP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _OTH_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _CNF_: {
      path: "",
      fileName: "",
      name: "",
      msg: "",
    },
    ADD2: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _BDP_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _COC_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
    _DDI_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    },
  })

  const [responseDocumentProposer, setResponseDocumentProposer] = useState({
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PAP_:  [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }] ,
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }
      })
  const [documentPR, setdocumentPR] = useState({
    _CAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PAP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _IDP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }],
    _PHO_: {
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }
      })
  const [responseDocumentJointlife, setResponseDocumentJointlife] = useState({
    _AGP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }]
  })
  const [documentSA, setdocumentSA] = useState({
    _AGP_: [{
      location: "",
      fileName: "",
      msg: "",
      name : ""
    }]
  })
  const [disable, setDisable] = useState(false)
  const [disablePermanentAddress,setDisablePermanentAddress]=useState(false)
  const [disableAadhar, setDisableAadhar] = useState(false)
  const [disableProposer, setDisableProposer] = useState(false)
  const [disableJointlife, setDisableJointLife] = useState(false)
  const [disabledMessage, setDisabledMessage] = useState("")
  const [permanentAddressDisableMessage,setPermanentAddressDisableMessage]=useState("")
  const [disabledMessageAadhar, setDisabledMessageAadhar] = useState("")
  const [disabledMessageProposer, setDisabledMessageProposer] = useState("")
  const [addressProceedPermanent, setAddressProceedPermanent] = useState(false)
  const [digilockerLA, setDigilockerLA] = useState(false)
  const [digilockerSA, setDigilockerSA] = useState(false)
  const [digilockerPR, setDigilockerPR] = useState(false)
  const [disableAGP, setdisableAGP] = useState(false)
  const [disableAGPmessage, setdisableAGPmessage] = useState("")
  const [disableAadhaarDL, setdisableAadhaarDL] = useState(false)
  const [disableAadhaarMessage, setdisableAadhaarMessage] = useState("")
  const [disableIDP, setdisableIDP] = useState(false)
  const [disableIDPmessage, setdisableIDPmessage] = useState("")
  const [disableADP, setdisableADP] = useState(false)
  const [disableADPmessage, setdisableADPmessage] = useState("")
  const [disableIDPPR, setdisableIDPPR] = useState(false)
  const [disableIDPPRmessage, setdisableIDPPRmessage] = useState("")
  const [disableADPPR, setdisableADPPR] = useState(false)
  const [disableADPPRmessage, setdisableADPPRmessage] = useState("")
  const [disableAGPSA, setdisableAGPSA] = useState(false)
  const [disableAGPSAmessage, setdisableAGPSAmessage] = useState("")
  const [addressProceedPermanentProposer, setAddressProceedPermanentProposer] = useState(false)
  const [allJourneyData, setAllJourneyData] = useState()
  const [paymentMethod, setPaymentMethod] = useState("")
  const [retreiveUploadedDocumentsData, setRetreiveUploadedDocuments] = useState()
  const [docOptions, setDocOptions] = useState()
  const [selectedOption, setSelectedOption] = useState()
  const [selectedOptionData, setSelectedOptionData ] = useState()
  const [disableProposerPermanentAddress, setDisableProposerPermanentAddress]=useState(false)
  const [permanentProposerAddressDisableMessage,setProposerPermanentAddressDisableMessage]=useState("")
  const [previewImgSrc,setPreviewImgSrc] = useState('')
  // Preview state for inline/modal image preview before upload
  const [eventState,setEventState] = useState('')
  const [field,setField] = useState('')
  const [previewIncomeProofType, setPreviewIncomeProofType] = useState(null)
  const [previewCallbackType, setPreviewCallbackType] = useState(null)
  const prevPreviewImgSrcRef = useRef("")
  const [VCOption, setVCOption] = useState('')
  const [anurConfigChannels, setAnurConfigChannels] = useState([])
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [vcOptionClicked,setVCOptionClicked] =useState(false);
  const [isPivcCompleted, setIsPivcCompleted] = useState(false);
  const [vcTimerActive, setVCTimerActive] = useState(false); // Timer state
  const [vcTimeLeft, setVCTimeLeft] = useState(0); //time left state
  const [vcIdProof, setVcIdProof] = useState(null); // Add state for base64
  const [vcIdProofName, setVcIdProofName] = useState(""); // name of base64 img
  const [docGridData, setDocGridData] = useState(null); // stores API response
  const [selectedIncomeProofOptions, setSelectedIncomeProofOptions] = useState({}); // maps docType to selected dropdown option

  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);

  const isLifeAssuredCkycOptional =
    allJourneyData?.lifeAssuredDetails?.ckycVerified === true &&
    String(allJourneyData?.lifeAssuredDetails?.proceedWith || "").toLowerCase() === "ckyc"
  const isProposerCkycOptional =
    allJourneyData?.proposerDetails?.ckycVerified === true &&
    String(allJourneyData?.proposerDetails?.proceedWith || "").toLowerCase() === "ckyc"

  const handleVCIdProofChange = (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;
      if (!uploadFileValidations(file)) return;
      const formData = new FormData();
      formData.append("image", file);
      setVcIdProof(formData);
      setVcIdProofName(file.name);
      // New ID proof selected, require user to click Proceed Now again
      setVCOptionClicked(false);
    } catch (error) {
      errorToastr(error.message)
      setVcIdProof(null)
      setVcIdProofName("")
    }
  };

  const collectDocGridPayload = () => {
    // Get all journey data
    const annualIncome = allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome || 0;
    const education = allJourneyData?.lifeAssuredDetails?.employmentDetails?.education || "10";
    const occupation = allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation || "1";
    const sumAssured = allJourneyData?.productDetails?.sumAssured || 0;
    const isLaAndPropSame = allJourneyData?.lifeAssuredDetails?.isLaAndPropSame || "N";
    
    // Get annualizedPremium from BI (you need to ensure biApiData is available)
    const annualizedPremium = allJourneyData?.productDetails?.sumAssured || 0;
    
    // Check health indicator from medical questions - Y if any medical question is Y
    const medicalInfo = allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalInfo || {};
    const medicalQuestions = allJourneyData?.lifeAssuredDetails?.medicalDetails?.healthQuestions?.medicalQuestions || {};
    
    // Check all medical question indicators from medicalInfo
    const hasAnyMedicalYes = 
      medicalInfo?.hltQn1?.hltQn1Ind === "Y" ||
      medicalInfo?.hltQn2?.hltQn2Ind === "Y" ||
      // Check all medical question indicators from medicalQuestions
      medicalQuestions?.subHltQn1?.hltQn1i?.hltQn1iInd === "Y" ||
      medicalQuestions?.subHltQn1?.hltQn1ii?.hltQn1iiInd === "Y" ||
      medicalQuestions?.subHltQn1?.hltQn1iii?.hltQn1iiiInd === "Y" ||
      medicalQuestions?.subHltQn1?.hltQn1v?.hltQn1vInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2i?.hltQn2iInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2ii?.hltQn2iiInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2iii?.hltQn2iiiInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2iv?.hltQn2ivInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2v?.hltQn2vInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2vi?.hltQn2viInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2vii?.hltQn2viiInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2viii?.hltQn2viiiInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2ix?.hltQn2ixInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2x?.hltQn2xInd === "Y" ||
      medicalQuestions?.hltQn2?.hltQn2xi?.hltQn2xiInd === "Y";
    
    const healthInd = hasAnyMedicalYes ? "Y" : "N";
    
    // laeqPR - needs product form type check
    const laeqPR = isLaAndPropSame === "Y" ? "Y" : "N"; // This is simplified
    
    return {
      "applicationNumber": journeyState?.applicationNo,
      "annualIncome": annualIncome,
      "annualizedPremium": annualizedPremium,
      "creditScore": "0", // TODO: Get from CIBIL API
      "education": education,
      "fcrrRating": "MEDIUM", // TODO: Get from FCRR API response
      "healthInd": healthInd,
      "laeqPR": laeqPR, // TODO: Add product form logic
      "occupation": occupation,
      "sumAssured": sumAssured,
      "totalSumUnderConsideration": 0.0, // TODO: Get from FCRR API response
      "trc": 0.0 // TODO: Get from FCRR API response
    }
  }

  const shouldShowDropdown = (docCode) => {
    return docGridConfig[docCode]?.showDropdown || false
  }

  const getDocTypeFromGridCode = (docCode) => {
    return docGridConfig[docCode]?.docType || `_${docCode}_`
  }

  const effectiveRequiredDocs = (docGridData?.requiredDocs || []).filter((docCode) => {
    const docType = getDocTypeFromGridCode(docCode)
    // When hardcoded _IPL_ upload is visible, avoid duplicate doc-grid card for same docType.
    if (docType === "_IPL_" || docType === "_SOW_") {
      return false
    }
    return true
  })

  const getUploadDocPurpose = (docType) => {
    // Check if this docType is from document grid config
    const docGridEntry = Object.values(docGridConfig).find(config => config.docType === docType)
    if (docGridEntry && docGridEntry.uploadDocPurpose) {
      return docGridEntry.uploadDocPurpose
    }
    // Fallback to original logic for non-grid documents (existing functionality)
    return docType.split("_")[1]
  }

const startCamera = () => {
  setShowCamera(true);
};


const stopCamera = () => {
  stream?.getTracks().forEach(track => track.stop());
  setStream(null);
  setShowCamera(false);
};


  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    canvas.toBlob(blob => {
      const file = new File([blob], "captured_photo.jpg", {
        type: "image/jpeg"
      });

      // Reuse existing upload logic
      const fakeEvent = {
        target: {
          files: [file]
        }
      };

      uploadFile(fakeEvent, "_PHO_", true);
      stopCamera();
    }, "image/jpeg", 0.9);
  };

  useEffect(() => {
  if (!showCamera) return;

  let mediaStream;

  const initCamera = async () => {
    try {
      mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false
      });

      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
        videoRef.current.play();
      }

      setStream(mediaStream);
    } catch (error) {
      console.error("Camera error:", error);
      alert("Unable to access camera");
      setShowCamera(false);
    }
  };

  initCamera();

  return () => {
    mediaStream?.getTracks().forEach(track => track.stop());
  };
}, [showCamera]);


  useEffect(() => {
    let timer;
    if (vcTimerActive) {
      setVCTimeLeft(30); // Start at 30 seconds
      timer = setInterval(() => {
        setVCTimeLeft(prev => {
          if (prev <= 1) {
            setVCTimerActive(false);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setVCTimeLeft(0);
    }
    return () => clearInterval(timer);
  }, [vcTimerActive]);

  useEffect(() => {
    if (!["EQUITAS", "equitas", "36"].includes(props?.channel) || !journeyState.applicationNo) return

    let isActive = true

    // Trigger SP enrichment on page load for Equitas channel (fire-and-forget)
    triggerSpEnrichment(journeyState.applicationNo)

    const syncPivcStatusOnLoad = async () => {
      try {
        const pivcPayload = {
          WSO2Token: accessToken,
          application_no: journeyState.applicationNo,
        }
        const pivcRes = await getAnurPivcStatus(pivcPayload)
        if (!isActive) return

        const pivcCompleted = pivcRes?.data?.PIVC_completed === "Y"
        setIsPivcCompleted(pivcCompleted)
        setIsPivcPending(false)
        if (pivcCompleted) {
          setVCOptionClicked(true)
          setPivcSubmitError("")
        }
      } catch (error) {
        if (!isActive) return
        console.error("Error while checking Anur PIVC status on load", error)
      }
    }

    syncPivcStatusOnLoad()

    return () => {
      isActive = false
    }
  }, [props?.channel, journeyState.applicationNo])

  useEffect(() => {
    if (!["EQUITAS", "equitas", "36"].includes(props?.channel)) return
    if (!showSpDetailsModal || !journeyState.applicationNo) return

    return startSpEnrichmentPolling(journeyState.applicationNo, () => {
      setShowSpDetailsModal(false)
    })
  }, [showSpDetailsModal, journeyState.applicationNo, props?.channel])

  // Preview modal: prevent background scroll (no auto-scroll/jump).
  useEffect(() => {
    if (typeof document === "undefined") return

    prevPreviewImgSrcRef.current = previewImgSrc

    if (!previewImgSrc) {
      document.body.style.overflow = ""
      return
    }

    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = ""
    }
  }, [previewImgSrc]);


  useEffect(() => {
    let payload = {
      journeyId: journeyState.journeyId,
    }
    fetchAllJourneyData(payload).then(res => {
      setAllJourneyData(res)
      console.log(res.lifeAssuredDetails, "fetchAlljourneyData response")
      if(res?.consentHandle){
        let payloadForStatus = {
          "consentHandle": res?.consentHandle
        }
        let finarkein = finarkeinStatus(payloadForStatus)
      }
      if (res.lifeAssuredDetails?.kycVerified === true) {
        setDisable(true)
        setDisableAadhar(true)
        setDisabledMessageAadhar("Waived Off")
        setDisabledMessage("Waived Off")
        if (res.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
          setAddressProceedPermanent(true)
          setDisablePermanentAddress(true)
          setPermanentAddressDisableMessage("Waived Off")
        }
      } else if (res.lifeAssuredDetails?.ckycVerified === true) {
        setDisable(true)
        setDisabledMessage("Waived Off")
        if (res.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
          setAddressProceedPermanent(true)
          setDisablePermanentAddress(true)
          setPermanentAddressDisableMessage("Waived Off")
        }
      } else {
        setDisable(false)
        setDisabledMessage("")
      }
      if (res?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
        setDisableJointLife(true)
      } else {
        setDisableJointLife(false)
      }
      if (res?.lifeAssuredDetails?.isLaAndPropSame === "N") {
        if (res.proposerDetails?.kycVerified === true) {
          if(res.proposerDetails?.addressProceedWith === "both" || res.proposerDetails?.addressProceedWith === "currentAddress"){
            setDisableProposer(true)
            setDisabledMessageProposer("Waived Off")
          }
          else if (res.proposerDetails?.addressProceedWith === "permanentAddress") {
            setDisableProposerPermanentAddress(true)
            setProposerPermanentAddressDisableMessage("Waived Off")
          }
        } else if (res.proposerDetails?.ckycVerified === true) {
            if(res.proposerDetails?.addressProceedWith === "both" || res.proposerDetails?.addressProceedWith === "currentAddress"){
              setDisableProposer(true)
              setDisabledMessageProposer("Waived Off")
            }
            else if (res.proposerDetails?.addressProceedWith === "permanentAddress" ) {
              setDisableProposerPermanentAddress(true)
              setProposerPermanentAddressDisableMessage("Waived Off")
            }
        } else {
          setDisableProposer(false)
          setDisabledMessageProposer("")
        }
      }
      if(res?.journeyType?.toLowerCase() === "canarapos"){
        retreiveUploadedDocumentsFunction()
      }
      if(journeyState.digiLockerOption && !(res?.basicDetails?.AGPLA || res?.basicDetails?.IDPLA || res?.basicDetails?.ADPLA || res?.basicDetails?.AadhaarUpload || res?.basicDetails?.AGPSA || res?.basicDetails?.IDPPR || res?.basicDetails?.ADPPR)){
        errorToastr("Documents not available")
      }
      if(res?.basicDetails?.digiLockerRedirectLA){
        setDigilockerLA(true)
        if(journeyState.digiLockerOption === "LA" && (res?.basicDetails?.AGPLA || res?.basicDetails?.IDPLA || res?.basicDetails?.ADPLA || res?.basicDetails?.AadhaarUpload)){
          successToastr("Documents uploaded successfully")
        }
        if(res?.basicDetails?.AGPLA){
          setdisableAGP(true)
          setdisableAGPmessage("Waived Off")
        }
        if(res?.basicDetails?.IDPLA){
          setdisableIDP(true)
          setdisableIDPmessage("Waived Off")
        }
        if(res?.basicDetails?.ADPLA){
          setdisableADP(true)
          setdisableADPmessage("Waived Off")
        }
        if(res?.basicDetails?.AadhaarUpload){
          setdisableAadhaarDL(true)
          setdisableAadhaarMessage("Waived Off")
        }
      }
      if(res?.basicDetails?.digiLockerRedirectSA){
        if(journeyState.digiLockerOption === "SA" && res?.basicDetails?.AGPSA){
          successToastr("Documents uploaded successfully")
        }
        setDigilockerSA(true)
        if(res?.basicDetails?.AGPSA){
          setdisableAGPSA(true)
          setdisableAGPSAmessage("Waived Off")
        }
      }
      if(res?.basicDetails?.digiLockerRedirectPR){
        if(journeyState.digiLockerOption === "PR" && (res?.basicDetails?.IDPPR || res?.basicDetails?.ADPPR)){
          successToastr("Documents uploaded successfully")
        }
        setDigilockerPR(true)
        if(res?.basicDetails?.IDPPR){
          setdisableIDPPR(true)
          setdisableIDPPRmessage("Waived Off")
        }
        if(res?.basicDetails?.ADPPR){
          setdisableADPPR(true)
          setdisableADPPRmessage("Waived Off")
        }
      }

      let paymentMethod
      res?.transactionDetails?.transactions?.find((transaction, index) => {
        if (transaction.status === "Success" && transaction?.paymentMethod?.toLowerCase() === "cheque") {
          paymentMethod = "cheque"
        } else if (transaction.status === "Success" && transaction?.paymentMethod?.toLowerCase() === "dd") {
          paymentMethod = "dd"
        }
        setPaymentMethod(paymentMethod)
      })
      let data = {
        applicationNumber: journeyState.applicationNo
      }
      getAllTempDocuments(data)
      .then(documents => {
        console.log(documents)
        // let docList = []
        let docType = ["CAP","PAP", "IDP", "AGP", "SOW", "UID", "PHO", "DDI", "COC", "BDP", "ADD2", "OTH", "CNF"]
        let tempUploadDocuments = {
          _UID_:[{
            path: "",
            name: "",
            msg: "",
          }],
          _PHO_: {
            path: "",
            name: "",
            msg: "",
          },
          _ADE_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _IDP_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _SOW_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _CAP_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _PAP_:[{
            path: "",
            name: "",
            msg: "",
          }],
          _AGP_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _OTH_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _CNF_: {
            path: "",
            name: "",
            msg: "",
          },
          ADD2: {
            path: "",
            name: "",
            msg: "",
          },
          _BDP_: {
            path: "",
            name: "",
            msg: "",
          },
          _COC_: {
            path: "",
            name: "",
            msg: "",
          },
          _DDI_: {
            path: "",
            name: "",
            msg: "",
          },
        }
        let tempUploadDocumentsProposer = {
          _PHO_: {
            path: "",
            name: "",
            msg: "",
          },
          _IDP_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _CAP_: [{
            path: "",
            name: "",
            msg: "",
          }],
          _PAP_:[{
            path: "",
            name: "",
            msg: "",
          }],
        }
        let tempUploadDocumentsJointLife = {
          _AGP_: [{
            path: "",
            name: "",
            msg: "",
          }]
        }
        let tempDocNumberCount = {
          _UID_: {
            count: 1
          },
          _PHO_: {
            count: 1
          },
          _IDP_: {
            count: 1
          },
          _SOW_: {
            count: 1
          },
          _CAP_: {
            count: 1
          },
          _PAP_:{
            count: 1
          },
          _AGP_: {
            count: 1
          },
          _OTH_: {
            count: 1
          },
          _CNF_: {
            count: 1
          },
          ADD2: {
            count: 1
          },
          _COC_: {
            count: 1
          },
          _DDI_: {
            count: 1
          },
        }
        let tempDocNumberCountProposer = {
          _PHO_: {
            count: 1
          },
          _IDP_: {
            count: 1
          },
          _CAP_: {
            count: 1
          },
          _PAP_:{
            count: 1
          },
        }
        let tempDocNumberCountJointLife = {
          _AGP_: {
            count: 1
          },
        }
        documents?.data?.documents.map(doc => {
          if(docType.includes(doc.docPurpose) && doc.active){
            let location = doc.path
            let encryptedToken = aesEncryptData({ accessToken: accessToken })
            let base64EncodedToken = base64.encode(encryptedToken)
            // console.log("base64EncodedToken", base64EncodedToken)
            let newLocation = `${location}?auth=${base64EncodedToken}`
            doc.path = newLocation
            // let obj = {
            //   [`_${doc.docPurpose}_`]: doc
            // }
            // docList.push(obj)
            }
            const singleDoc = ["PHO","CNF","COC","DDI","ADD2","ADD2","BDP"]
            if(docType.includes(doc.docPurpose)){
            if (doc.option === "LA"){
              if (!singleDoc.includes(doc.docPurpose)){
                tempDocNumberCount[`_${doc.docPurpose}_`].count++;
              }else{
                tempDocNumberCount[`_${doc.docPurpose}_`].count = 1;
              }
            }else if (doc.option === "SA"){
              if (!singleDoc.includes(doc.docPurpose)){
                tempDocNumberCountJointLife[`_${doc.docPurpose}_`].count++;
              }else{
                tempDocNumberCountJointLife[`_${doc.docPurpose}_`].count = 1;
              }
            }else if (doc.option === "PR"){
              if (!singleDoc.includes(doc.docPurpose)){
                tempDocNumberCountProposer[`_${doc.docPurpose}_`].count++;
              }else{
                tempDocNumberCountProposer[`_${doc.docPurpose}_`].count = 1;
              }
            }
            if(doc.option === "LA"){
              if (doc.docPurpose === "PHO" || doc.docPurpose === "ADD2" || doc.docPurpose === "COC" || doc.docPurpose === "DDI" || doc.docPurpose === "CNF"){
                tempUploadDocuments[`_${doc.docPurpose}_`] = doc
              }else{
                tempUploadDocuments[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocuments[`_${doc.docPurpose}_`],
                  doc
                ]
              }
            } else if(doc.option === "PR"){
              if (doc.docPurpose === "PHO"){
                tempUploadDocumentsProposer[`_${doc.docPurpose}_`] = doc
              }else{
                tempUploadDocumentsProposer[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocumentsProposer[`_${doc.docPurpose}_`],
                  doc
                ]
              }
            } else{
                tempUploadDocumentsJointLife[`_${doc.docPurpose}_`] = [
                  ...tempUploadDocumentsJointLife[`_${doc.docPurpose}_`],
                  doc
                ]
            }
          }
        })
        // Additive: hydrate document-grid uploads for resume links.
        // Legacy resume hydration only restores hardcoded doc purposes; doc-grid docs use config-based docType keys.
        const normalizeDocPurpose = (docPurpose = "") => `${docPurpose}`.replace(/^_+|_+$/g, "") // NOSONAR
        const gridPurposeToDocTypeMap = Object.values(docGridConfig).reduce((acc, config) => {
          const normalizedPurpose = normalizeDocPurpose(config?.uploadDocPurpose)
          if (normalizedPurpose) {
            acc[normalizedPurpose] = config.docType
          }
          return acc
        }, {})
        let tempSelectedIncomeProofOptions = {}
        const hydrateGridUploadedDocs = (gridDoc) => {
          const normalizedDocPurpose = normalizeDocPurpose(gridDoc?.docPurpose)
          // Skip if legacy path already handles this docPurpose
          if (docType.includes(gridDoc?.docPurpose)) return
          const mappedDocType = gridPurposeToDocTypeMap[normalizedDocPurpose]
          if (!mappedDocType) return
          if (!gridDoc?.active) return

          // Ensure authenticated URL for downloads / preview flows.
          if (gridDoc?.path) {
            let encryptedToken = aesEncryptData({ accessToken: accessToken })
            let base64EncodedToken = base64.encode(encryptedToken)
            gridDoc.path = `${gridDoc.path}?auth=${base64EncodedToken}`
          }

          if (!Array.isArray(tempUploadDocuments[mappedDocType])) {
            tempUploadDocuments[mappedDocType] = [{
              path: "",
              name: "",
              location: "",
              msg: ""
            }]
          }

          // Try to auto-set the dropdown based on what the temp-doc API returns.
          // Select options use the key from `docGridData.incomeProofDocs`, so we try the common fields.
          const dropdownValue =
            gridDoc?.incomeProofType ||
            gridDoc?.fileCode ||
            gridDoc?.fileCodeValue ||
            gridDoc?.type ||
            gridDoc?.description
          if (dropdownValue && !tempSelectedIncomeProofOptions[mappedDocType]) {
            tempSelectedIncomeProofOptions[mappedDocType] = dropdownValue
          }

          // Append uploaded doc; UI renders from slice(1), so index 0 remains placeholder.
          tempUploadDocuments[mappedDocType].push(gridDoc)

          if (!tempDocNumberCount[mappedDocType]) {
            tempDocNumberCount[mappedDocType] = { count: 1 }
          }
          // Keep count in sync with array length (placeholder + uploaded docs).
          tempDocNumberCount[mappedDocType].count = tempUploadDocuments[mappedDocType].length
        }

        documents?.data?.documents?.forEach(hydrateGridUploadedDocs)
        if (Object.keys(tempSelectedIncomeProofOptions).length > 0) {
          setSelectedIncomeProofOptions(prev => ({
            ...prev,
            ...tempSelectedIncomeProofOptions
          }))
        }
        setUploadedDocuments(prev => ({
          ...prev,
          ...tempUploadDocuments
        }))
        setDocNumber(prev => {
          return {
            ...prev,
            ...tempDocNumberCount
          }
        })
        setdocumentPR(prev => ({
          ...prev,
          ...tempUploadDocumentsProposer
        }))
        setDocNumberProposer(prev => {
          return {
            ...prev,
            ...tempDocNumberCountProposer
          }
        })
        setdocumentSA(prev => ({
          ...prev,
          ...tempUploadDocumentsJointLife
        }))
        setDocNumberjointLife(prev => {
          return {
            ...prev,
            ...tempDocNumberCountJointLife
          }
        })
      })
    })
  }, [])

  useEffect(()=>{
    if(allJourneyData){
       getConfigByType({type:"anur-config"}).then(res=>{
      if(res?.data[0]?.config?.products?.hasOwnProperty(allJourneyData?.journeyIdFromStrapi)){
        let channels=res?.data[0]?.config?.products?.[allJourneyData?.journeyIdFromStrapi]?.channels || [];
        channels=channels.map(c=>c.toUpperCase());
        setAnurConfigChannels(channels)
      }
    }).catch(error=>{
      console.error(error)
      errorToastr(error?.response?.data?.message || error.message)
    })
    }
  },[allJourneyData])

  useEffect(()=>{
    if(true){
      const payload = collectDocGridPayload()
      getDocGrid(payload).then(res=>{
        setDocGridData(res)
        // Initialize doc numbers for each required document using mapped docType
        if(res?.requiredDocs){
          setDocNumber(prev => {
            const updated = { ...prev }
            res.requiredDocs.forEach(docCode => {
              const docType = getDocTypeFromGridCode(docCode)
              if(!updated[docType]){
                updated[docType] = { count: 1 }
              }
            })
            return updated
          })
          // Initialize in existing responseDocument state if not already present
          setResponseDocument(prev => {
            const updated = { ...prev }
            res.requiredDocs.forEach(docCode => {
              const docType = getDocTypeFromGridCode(docCode)
              if(!updated[docType]){
                updated[docType] = [{
                  location: "",
                  fileName: "",
                  msg: "",
                  name: ""
                }]
              }
            })
            return updated
          })
          // Initialize in uploadedDocuments state if not already present
          setUploadedDocuments(prev => {
            const updated = { ...prev }
            res.requiredDocs.forEach(docCode => {
              const docType = getDocTypeFromGridCode(docCode)
              if(!updated[docType]){
                updated[docType] = [{
                  path: "",
                  name: "",
                  location: "",
                  msg: ""
                }]
              }
            })
            return updated
          })
        }
      }).catch(error=>{
        console.error(error)
        errorToastr(error?.response?.data?.message || error.message)
      })
    }
  },[allJourneyData])

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [errorState, setErrorState] = useState("")
  const [bankingOptionSelect, setBankingOptionSelect] = useState("")

  const showDocumentUploadErrorToaster = (error) => {
    console.error("Document upload failed:", error)
    errorToastr(DOCUMENT_UPLOAD_SUPPORT_MESSAGE)
  }

  const handleFileEnter = (event, inputId) => {
    if (event.key == 'Enter') {
      let el = document.getElementById(inputId)
      el.click()
    }

  }

  const handlePerfiosEnter = (event) => {
    if (event.key == 'Enter') {
      navigateToPerfiosUrl()

    }
  }

  const handleChangeBankingOption = (event) => {

    if (event.key == "Enter") {
      changeBankingOption(event)

    }
  }

  const handlePreview = (e,field,callbackType) => {
    const fileInput = e.target;
    const file = fileInput.files[0];
    if (file) {
      if (file.type.startsWith('image/')){
        const reader = new FileReader();
        reader.onload = function (e) {
          setPreviewCallbackType(callbackType)
          setPreviewImgSrc(e.target.result)
        };
        reader.readAsDataURL(file);
      }else{
        if (callbackType === "la"){
          uploadFile(e,field,false)
        }else if (callbackType === "pr"){
          uploadFileForProposer(e,field,false)
        }else if (callbackType === "jl"){
          uploadFileForJointlife(e,field,false)
        }
      }
    }
  }

  const uploadFile = async (e, field, isPreview = false, incomeProofType = null) => {
    if (isPreview){
      handlePreview(e,field,"la")
      setField(field)
      setEventState(e)
      setPreviewIncomeProofType(incomeProofType) // Store for preview modal upload
      return;
    }

    if(docNumber?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    let componentFormControlKey
    if(field === "_PHO_"){
      componentFormControlKey = 'photoUpload'
    }else if(field === "_IDP_"){
      componentFormControlKey = 'idProofUpload'
    }else if(field === "_SOW_"){
      componentFormControlKey = 'incomeProofUpload'
    }else if(field === "_CAP_"){
      componentFormControlKey = 'addressProofUpload'
    }else if(field === "_AGP_"){
      componentFormControlKey = 'ageProofUpload'
    }else if(field === "_UID_"){
      componentFormControlKey = 'aadharProofUpload'
    }else if(field === "_COC_"){
      componentFormControlKey = 'BankDocsUpload'
    }else if(field === "_DDI_"){
      componentFormControlKey = 'BankDocsUpload'
    }else if(field === "_OTH_"){
      componentFormControlKey = 'otherDocUpload'
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, componentFormControlKey, journeyState)
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    //check for file size
    if (file.size > 26214400) {
      errorToastr("Maximum file size allowed is 25 Mb")
      return
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff","tif", "pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type.toLowerCase())) {
      errorToastr("File not supported")
      return
    }

    let formData = new FormData()
    const singleDoc = ["_PHO_","_CNF_","_COC_","_DDI_","_ADD2_","_BDP_"]
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
      if(singleDoc.includes(field)){
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "." +
        name.split(".")[1]
        )
      }
      else {
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "0" + docNumber?.[`${field}`]?.count + "." +
        name.split(".")[1]
        )
      }
      formData.append(
        "uploadDocPurpose", getUploadDocPurpose(field)
      )
      // Add income proof type if provided (from parameter or stored from preview)
      const finalIncomeProofType = incomeProofType || previewIncomeProofType
      if(finalIncomeProofType){
        formData.append("incomeProofType", finalIncomeProofType)
      }
      console.log(formData)

      // Determine option from field - if field contains PR-related codes, use PR, else LA
      const option = (field.includes("PR") || field.includes("_PR_")) ? "PR" : "LA"

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: option
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        if(singleDoc.includes(field))
        {
          setResponseDocument({
            ...responseDocument,
            [field]: res,
           })
        }else {
          if (responseDocument?.[`${field}`].length === 1){
            if (uploadedDocuments?.[`${field}`].length > 1){
              let tempResposneDocument = []
              uploadedDocuments?.[`${field}`]?.map(doc => {
                tempResposneDocument.push({
                  location : doc.path,
                  fileName : doc.name,
                  name : doc.name,
                  msg : ""
                })
              })
              setResponseDocument({
                ...responseDocument,
                [field]: [
                  ...tempResposneDocument,
                  res
                ],
              });
            }else{
              setResponseDocument({
                ...responseDocument,
                [field]: [
                  ...responseDocument[`${field}`],
                  res
                ],
              });
            }
          }else{
            setResponseDocument({
              ...responseDocument,
              [field]: [
                ...responseDocument[`${field}`],
                res
              ],
            });
          }
        }
        if (!singleDoc.includes(field)){
          setDocNumber({
            ...docNumber,
            [field]: {
              count: docNumber?.[`${field}`]?.count + 1
            },
          })
        }else{
          setDocNumber({
            ...docNumber,
            [field]: {
              count: 1
            },
          })
        }
        setIsUploading(false)
        setPreviewIncomeProofType(null) // Clear after successful upload
      } catch (error) {
        setIsUploading(false)
        setPreviewIncomeProofType(null) // Clear on error
        showDocumentUploadErrorToaster(error)
      }
    }
    let eventName = ""
    var formControlKey
    if(field == "_PHO_"){
       formControlKey = "photoUpload"
    }else if(field == "_IDP_"){
      formControlKey = "idProofUpload"
    }else if(field == "_SOW_"){
      formControlKey = "incomeProofUpload"
    }else if(field == "_CAP_"){
      formControlKey = "addressProofUpload"
    }else if(field == "_AGP_"){
      formControlKey = "ageProofUpload"
    }else if(field == "_OTH_"){
      formControlKey = "otherDocUpload"
    }else if (field == "_UID_"){
      formControlKey = "aadharProofUpload"
    }
  }

  const uploadFileForProposer = async (e, field,isPreview = false) => {
    if (isPreview){
      handlePreview(e,field,"pr")
      setField(field)
      setEventState(e)
      return;
    }
    if(docNumberProposer?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    if(!uploadFileValidations(file)) return;

    let formData = new FormData()
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
      if(field === "_PHO_"){
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "." +
        name.split(".")[1]
        )
      }
      else {
        formData.append(
          "docPurpose", Date.now() + "-" +
          field + "0" + docNumberProposer?.[`${field}`]?.count + "." +
        name.split(".")[1]
        )
      }
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: "PR"
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        if(field === "_PHO_")
        {
          setResponseDocumentProposer({
            ...responseDocumentProposer,
            [field]: res,
           })
        }else {
          if (responseDocumentProposer?.[`${field}`].length === 1){
            if (documentPR?.[`${field}`].length > 1){
              let tempResposneDocument = []
              documentPR?.[`${field}`]?.map(doc => {
                tempResposneDocument.push({
                  location : doc.path,
                  fileName : doc.name,
                  msg : ""
                })
              })
            
              setResponseDocumentProposer({
                ...responseDocumentProposer,
                [field]: [
                  ...tempResposneDocument,
                  res
                ],
              });
            }else{
              setResponseDocumentProposer({
                ...responseDocumentProposer,
                [field]: [
                  ...responseDocumentProposer[`${field}`],
                  res
                ],
              });
            }
          }else{
            setResponseDocumentProposer({
              ...responseDocumentProposer,
              [field]: [
                ...responseDocumentProposer[`${field}`],
                res
              ],
            });
          }
        }
        const singleDoc = ["_PHO_","_CNF_","_COC_","_DDI_","_ADD2_",,"_BDP_"]
        if (!singleDoc.includes(field)){
          setDocNumberProposer({
            ...docNumberProposer,
            [field]: {
              count: docNumberProposer?.[`${field}`]?.count + 1
            },
          })
        }else{
          setDocNumberProposer({
            ...docNumberProposer,
            [field]: {
              count: 1
            },
          })
        }
       
        setIsUploading(false)
      } catch (error) {
        setIsUploading(false)
        showDocumentUploadErrorToaster(error)
      }
    }
  }

  const uploadFileValidations=(file)=>{
    //check for file size
    if (file.size > 26214400) {
      errorToastr("Maximum file size allowed is 25 Mb")
      return false
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return false
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff","tif","pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return false
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return false
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return false
    }
    return true;
  }
  const uploadFileForJointlife = async (e, field,isPreview = false) => {
    if (isPreview){
      handlePreview(e,field,"jl")
      setField(field)
      setEventState(e)
      return;
    }
    if(docNumberjointLife?.[`${field}`]?.count > 6){
      errorToastr("Maximum 6 images can be Uploaded")
      return
    }
    if (isUploading) {
      return
    }
    let file = e?.target?.files[0]
    console.log(file, "file")
    if (!file) {
      return
    }

    //check for file size
    if (file.size > 26214400) {
      errorToastr("Maximum file size allowed is 25 Mb")
      return
    }

    //check for double extension
    let hasDoubleFormat = file.name?.split(".")?.length > 2
    if (hasDoubleFormat) {
      errorToastr("This file is not supported")
      return
    }

    //Check for file format
    let fileFormat = file.name?.split(".")?.[1]
    console.log(fileFormat, "fileFormat")
    if (!fileFormat || !(["png","jpg", "jpeg", "tiff", "tif" ,"pdf"]).includes(fileFormat.toLowerCase())) {
      errorToastr("This file is not supported")
      return
    }

    //Check for null type
    if (file.size < 10) {
      errorToastr("Invalid file")
      return
    }

    //Check for mimetype
    if (!["image/x-png", "image/png", "application/pdf", "image/jpeg", "image/tiff"].includes(file.type)) {
      errorToastr("File not supported")
      return
    }

    let formData = new FormData()
    if (e?.target?.files.length) {
      console.log(e.target.files, "dsskjjsf")
      setIsUploading(true)
      const file = e.target.files[0]
      formData.append("doc", file)
      formData.append("sub", true)
      let name = e.target.files?.[0]?.name || ""
      formData.append(
        "docPurpose", Date.now() + "-" +
        field + "0" + docNumberjointLife?.[`${field}`]?.count + "." +
        name.split(".")[1]
      )
      formData.append(
        "uploadDocPurpose", field.split("_")[1]
      )
      console.log(formData)

      try {
        let payload = {
          applicationNumber: journeyState.applicationNo,
          option: "SA"
        }
        const res = await uploadTempDocument(formData, payload) //journeyState.applicationNo
        if(res?.location == ''){
          errorToastr("File not supported")
        }
        let location = res.location
        let encryptedToken = aesEncryptData({ accessToken: accessToken })
        let base64EncodedToken = base64.encode(encryptedToken)
        // console.log("base64EncodedToken", base64EncodedToken)
        let newLocation = `${location}?auth=${base64EncodedToken}`
        // console.log("newLocation", newLocation)
        res.location = newLocation
        res.name = name
        console.log({ res })
        if (responseDocumentJointlife?.[`${field}`].length === 1){
          if (documentSA?.[`${field}`].length > 1){
            let tempResposneDocument = []
            documentSA?.[`${field}`]?.map(doc => {
              tempResposneDocument.push({
                location : doc.path,
                fileName : doc.name,
                msg : ""
              })
            })
            setResponseDocumentJointlife({
              ...responseDocumentJointlife,
              [field]: [
                ...tempResposneDocument,
                res
              ],
            });
          }else{
            setResponseDocumentJointlife({
              ...responseDocumentJointlife,
              [field]: [
                ...responseDocumentJointlife[`${field}`],
                res
              ],
            });
          }
        }else{
          setResponseDocumentJointlife({
            ...responseDocumentJointlife,
            [field]: [
              ...responseDocumentJointlife[`${field}`],
              res
            ],
          });
        }
        setDocNumberjointLife({
          ...docNumberjointLife,
          [field]: {
            count: docNumberjointLife?.[`${field}`]?.count + 1
          },
        })
        setIsUploading(false)
      } catch (error) {
        setIsUploading(false)
        showDocumentUploadErrorToaster(error)
      }
    }
  }
  const isPdf = val => {
    if (!val) {
      return true
    }
    let format = val?.split(".")?.[val.split(".").length - 1]
    if (!format) {
      return true
    }
    return ["pdf","tiff","tif"].includes(format.toLowerCase())
  }

  const handleNavigateFinarkein = async () => {
    console.log("finarkein")
    let data = {
      "id": journeyState.journeyId,
      "applicationNo": journeyState.applicationNo,
      "mobileNo": allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.communicationDetails?.contactDetails?.mobileNo : allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo,
      "journeyIdFromStrapi": allJourneyData?.journeyIdFromStrapi
    }
    const finarkeinRes = await finarkeinGenerateLink(data)
    console.log(finarkeinRes)
    if (finarkeinRes.data) {
      // window.location.replace(res.data.Perfios_URL)
      window.open(finarkeinRes.data.redirectUrl, "_self");
      // setIsUploading(false)
    }
    
  }

  const navigateToPerfiosUrl = async (e, field) => {
    var radios = document.getElementsByName("perfiosUploadDocument1")
    var formValid = false
    var i = 0
    while (!formValid && i < radios.length) {
      if (radios[i].checked) formValid = true
      i++
    }

    if (!formValid) {
      if (field) {
        setErrorState("")
        uploadFile(e, field)
      } else {
        setErrorState("Must check one option!")
      }
    } else {
      if(field){
        setErrorState("")
        uploadFile(e, field)
      }else{
        try {
          setErrorState("")
          const res = await perfiosGenerateLink({
            applicationNo: journeyState.applicationNo,
            destination: bankingOptionSelect,
          })
          if (res.status) {
            // window.location.replace(res.data.Perfios_URL)
            window.open(res.data.Perfios_URL, "popup", "width=600,height=600")
            // setIsUploading(false)
          }
          console.log(res)
        } catch (err) {
          console.log(err)
        }
      }

      
    }

  }

  const changeBankingOption = $event => {
    setErrorState("")
    document.getElementById("file7").required = false
    setBankingOptionSelect($event.target.value)
  }

  const digiLockerRedirection = e => {
    let payloadData = {
      option: "LA",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }

  const digiLockerRedirectionPR = e => {
    let payloadData = {
      option: "PR",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }

  const digiLockerRedirectionSA = e => {
    let payloadData = {
      option: "SA",
      applicationNo: journeyState.applicationNo
    }
    let encryptData = CryptoJS.AES.encrypt(JSON.stringify(payloadData), process.env.ENCRYPT_KEY).toString();
    var encodedString = btoa(encryptData);
    let payload = {
      journeyId: journeyState.journeyIdFromStrapi
    }
    fetchDigilockerDetails(payload).then(async res => {
      console.log(res)
      let productKey = lookup?.urlLookup?.[journeyState.journeyIdFromStrapi]
      if (`${process.env.DEVELOPMENT}` === "Y") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
      else if (`${process.env.DEVELOPMENT}` === "N") {
        const url = `${process.env.DIGILOCKER_URL}?response_type=code&state=${encodedString}&code_challenge=${process.env.DIGILOCKER_CODE_CHALLENGE}&code_challenge_method=S256&client_id=${res.data.clientId}&redirect_uri=${process.env.GATSBY_URL}/${productKey}/digiLocker-redirection/`;
        window.open(url, "_self");
      }
    })
  }

  const scrollToFirstVisibleError = () => {
    if (typeof document === "undefined" || typeof window === "undefined") return

    const candidates = Array.from(
      document.querySelectorAll(
        [
          // errors shown below each upload box
          ".file-inp-err .input-error",
          ".file-inp-err label.error",
          ".file-inp-err .text-danger",
          // generic errors
          ".input-error",
          "label.error",
          ".text-danger",
        ].join(",")
      )
    )

    const firstVisible = candidates.find(el => {
      if (!el) return false
      const rect = el.getBoundingClientRect?.()
      if (!rect) return false
      // visible if it occupies some space in layout
      return (rect.width > 0 || rect.height > 0) && el.getClientRects().length > 0
    })

    if (!firstVisible) return

    const rect = firstVisible.getBoundingClientRect()
    const y = Math.max(0, rect.top + window.scrollY - 120) // offset for fixed header
    window.scrollTo({ top: y, behavior: "smooth" })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setSubmitted(true);
    setPivcSubmitError("")
    setIsPivcPending(false)
    let pivcCompletedForSubmit = false
    const isEquitasPivcChannel = ["EQUITAS", "equitas", "36"].includes(props?.channel)
    const isNonEquitasAnurVideoChannel = anurConfigChannels.includes(props?.channel?.toUpperCase())
    // After "submitted" flips, error nodes get rendered—scroll to the first one (mobile-friendly).
    if (typeof window !== "undefined") {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => scrollToFirstVisibleError())
      })
    }
    // Non-Equitas ANUR channels: user must click "Proceed Now" at least once before submitting documents.
    if (isNonEquitasAnurVideoChannel && !isEquitasPivcChannel && !vcOptionClicked) {
      if (typeof window !== "undefined") {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => scrollToFirstVisibleError())
        })
      }
      return
    }

    // Equitas/36 channels: block submission unless PIVC is completed (via API check).
    if (isEquitasPivcChannel) {
      try {
        const pivcPayload = {
          WSO2Token: accessToken,
          application_no: journeyState.applicationNo,
        }

        const pivcRes = await getAnurPivcStatus(pivcPayload)
        if (!pivcRes || pivcRes?.data?.PIVC_completed !== "Y") {
          setIsPivcCompleted(false)
          setIsPivcPending(true)
          if (typeof window !== "undefined") {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => scrollToFirstVisibleError())
            })
          }
          return
        }
        pivcCompletedForSubmit = true
        setIsPivcCompleted(true)
        setIsPivcPending(false)
      } catch (error) {
        console.error("Error while validating Anur PIVC status before submit", error);
        setIsPivcCompleted(false)
        setIsPivcPending(false)
        setPivcSubmitError("Unable to validate Video Verification status. Please try again.")
        return
      }
    }
    console.log(responseDocument)
    // console.log(addressProceedPermanent)
    // console.log(disabledMessage)
    console.log(disable)
    console.log(addressProceedPermanent,)
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    if(anurConfigChannels.includes(props?.channel?.toUpperCase()) && !vcOptionClicked){
      return;
    }
    // if(!VCOption){
    //   return;
    // } 

    // Equitas SP details validation: force sync and verify SP details before submit
    if (isEquitasPivcChannel) {
      try {
        const spValidation = await verifySpDetailsWithSync(journeyState.applicationNo)
        if (!spValidation.isValid) {
          console.warn("SP details missing:", spValidation.missingFields)
          setShowSpDetailsModal(true)
          return
        }
      } catch (spErr) {
        console.error("Error validating SP details before submit", spErr)
        // On error, allow submission to proceed (don't block on network failures)
      }
    }

    if ((responseDocument._PHO_.fileName == '' && uploadedDocuments._PHO_.name == '') ||
      (responseDocument["_SOW_"].length < 2 && uploadedDocuments._SOW_.length < 2)) {
      console.log(1)
      return
    }
    if (allJourneyData?.basicDetails.channel === "A" && paymentMethod === "cheque") {
      if (responseDocument._COC_.fileName == '' && uploadedDocuments._COC_.name == '') {
        console.log(7)
        return
      }
    }
    if (allJourneyData?.basicDetails.channel === "A" && paymentMethod === "dd") {
      if (responseDocument._DDI_.fileName == '' && uploadedDocuments._DDI_.name == '') {
        console.log(7)
        return
      }
    }
      if (!disable) {
        if (!disableIDP){
          if (responseDocument._IDP_.length < 2 && uploadedDocuments._IDP_.length < 2) {
            console.log(3)
            return
          }
        }
        if (!disableAGP){
          if (responseDocument._AGP_.length < 2 && uploadedDocuments._AGP_.length < 2) {
            console.log(4)
            return
          }
        }
        if (!disableADP){
          if (responseDocument._CAP_.length < 2 && uploadedDocuments._CAP_.length < 2 && responseDocument._PAP_.length < 2 && uploadedDocuments._PAP_.length < 2) {
            console.log(5)
            return
          }
        }
    }
    if(allJourneyData?.lifeAssuredDetails?.communicationDetails?.sameAsCurrentAddress === "N" ){
       if(!disablePermanentAddress){
        if (responseDocument._PAP_.length < 2 && uploadedDocuments._PAP_.length < 2 && responseDocument._CAP_.length < 2 && uploadedDocuments._CAP_.length < 2) {
          console.log(5)
          return
          }
        }
       }
    if (!disableAadhar && !disableAadhaarDL && props?.channel !== "36") {
      if (responseDocument._UID_.length < 2 && uploadedDocuments._UID_.length < 2) {
        console.log(5)
        return
      }
    } 
    if (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N") {
      if ((responseDocumentProposer._PHO_.fileName == '' && documentPR._PHO_.name == ''))
        {
          console.log(51)
          return
        }
      if (!disableProposer) {
        if (!disableADPPR){
          if (responseDocumentProposer._CAP_.length < 2 && documentPR._CAP_.length < 2 && responseDocumentProposer._PAP_.length < 2 && documentPR._PAP_.length < 2) {
            console.log(6)
            return
          }
        }
        
      }
      if(!disableIDPPR){
        if(!disableProposer && !disableProposerPermanentAddress){
          if (responseDocumentProposer._IDP_.length < 2 && documentPR._IDP_.length < 2) {
            console.log(3)
            return
          }
        }
      }
      if(allJourneyData?.proposerDetails?.communicationDetails?.sameAsCurrentAddress === "N" ){
        if(!disableProposerPermanentAddress){
         if (responseDocumentProposer._PAP_.length < 2 && documentPR._PAP_.length < 2 && responseDocumentProposer._CAP_.length < 2 && documentPR._CAP_.length < 2) {
           console.log(5)
           return
           }
         }
        }
      }
      if (allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
      if (!disableJointlife) {
        if(!disableAGPSA){
          if (responseDocumentJointlife._AGP_.length < 2 && documentSA._AGP_.length < 2) {
            console.log(10)
            return
          }
        }
        
      }
    }
    // Validate document grid documents
    if (effectiveRequiredDocs.length > 0) {
      for (const docCode of effectiveRequiredDocs) {
        const docType = getDocTypeFromGridCode(docCode)
        const needsDropdown = shouldShowDropdown(docCode)
        const selectedOption = selectedIncomeProofOptions[docType]
        
        if (needsDropdown && !selectedOption) {
          console.log(`Missing dropdown selection for ${docCode}`)
          return
        }
        if (responseDocument[docType]?.length < 2 && uploadedDocuments[docType]?.length < 2) {
          console.log(`Missing upload for ${docCode}`)
          return
        }
      }
    }
    console.log(22222)
    // getS3FilenetUpload(journeyState.applicationNo).then(res => {
    //   console.log(res.data)
    // })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex + 1,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      }
    }
    moveTempDocumentsToPermanentBucket({ applicationNumber: journeyState?.applicationNo })
      .then(res => {
        saveApplication(sendPayload)
          .then(async res => {

            // Execute post-save async APIs if channel matches
            if (["equitas", "EQUITAS", "36"].includes(allJourneyData?.basicDetails.channel)) {
              try {
                const latestJourneyData = await fetchAllJourneyData({ journeyId: journeyState.journeyId });
                const payload2 = {
                  data: latestJourneyData,
                  id: journeyState.journeyId
                };
                await flexiEdgeProposalForm(payload2);
              } catch (err) {
                // Log error but DO NOT block navigation
                console.error("Post-save async operations failed:", err);
              } finally {
                finalSubmissionBrowser({ journeyId: journeyState?.journeyId })
                  .catch(err => {
                    console.error("Final submission failed:", err);
                  });
              }
            }

            // ALWAYS move to next section on success of saveApplication
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode:
              props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })

          })
          .catch(err => {
            showDocumentUploadErrorToaster(err);
            console.error("saveApplication error:", err);
          });
      })
      .catch(err => {
        showDocumentUploadErrorToaster(err);
        console.error("moveTempDocumentsToPermanentBucket error:", err);
      });
  }

  const documentDownload = (ev, docName) => {
    ev.preventDefault()
    let url = retreiveUploadedDocumentsData?.fetchedDocuments.forEach((element, index)=>{
      if(element[index]["docName"] === docName){
        return element[index]["docPath"]
      }
    })
    // let url = link
    let encryptedToken = aesEncryptData({ accessToken: accessToken })
    let base64EncodedToken = base64.encode(encryptedToken)
    let newUrl = `${url}?auth=${base64EncodedToken}`
    return newUrl
  }


const downloadFile = (e, docLocation) => {
  e.preventDefault()
  let url = `${process.env.GATASBY_API_URL}/get-uploaded-file/${docLocation}`
    // let url = link
    let encryptedToken = aesEncryptData({ accessToken: accessToken })
    let base64EncodedToken = base64.encode(encryptedToken)
    let newUrl = `${url}?auth=${base64EncodedToken}`
    window.open(newUrl,"_self")
    return newUrl
}

const printFile = async (e, docLocation) => {
  e.preventDefault()
  let payload = {
      "proposerFormLink": docLocation,
      "applicationNumber": journeyState.applicationNo
  }
  let data = await s3DownloadDocuments(payload)
  let base64Data = data?.data

  const newWindow = window.open("", "", "width=100, height=100")
  if (newWindow) {
    const document = newWindow.document.open()
    document.close()
    newWindow.moveTo(0, 0)
    newWindow.resizeTo(window.screen.width, window.screen.height)
    const contentType = "application/pdf"
    const b64Data = base64Data
    const blob = b64toBlob(b64Data, contentType)
    const blobUrl = URL.createObjectURL(blob)
    document.write(`<iframe id="pdfDocument"
    src="${blobUrl}" 
    width="100%"
    height="100%"
    frameBorder="0" ></iframe>`)
    const docs = document.getElementById("pdfDocument")
    setTimeout(() => {
      docs.contentWindow.print()
    }, 1000)
  }

  function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
}

function getKeyByValue(value, object) {
  return object.find(key => key.description == value)
}

const handleChange = (value, object) => {
  // e.preventDefault()
  setSelectedOption(value.value)

  let selectedValue =  object.find(key => key.description == value.value)
  setSelectedOptionData(selectedValue)

  retreiveUploadedDocumentsFunction()

}

function retreiveUploadedDocumentsFunction(){
  retreiveUploadedDocuments({"applicationNumber":journeyState.applicationNo})
  .then(res => {
    console.log(res);
    setRetreiveUploadedDocuments(res?.data)
    let options = res?.data?.map((el) => {
      console.log(el);
      return el.description 
    })
    options = Object.entries(options)?.map(([key, val]) => ({
              value: val,
              label: val,
            }))
    console.log(options);
    setDocOptions(options)
    console.log(docOptions);
  })
  .catch(err => {
    console.log(err);
  })
}

function openModal(data,type) {
  const imageSrc = data.src
  var modal = document.getElementById("imageModal");
  var modalImage = document.getElementById("modalImage");
  modal.style.display = "block";
  modalImage.src = imageSrc;
  modalImage.setAttribute('data-modal-filename',data.getAttribute('data-filename'))
  modalImage.setAttribute('data-modal-doctype',data.getAttribute('data-doctype'))
  const heading = modal.querySelector("#image-preview-after-upload")
  const ele = document.getElementById("previewUpload2")
  ele.setAttribute("data-type",data.getAttribute("data-type") || "la")
  if (type === "pdf"){
    heading.innerText = data.getAttribute('data-name')
    heading.style.marginRight = "50px"
  }else{
    heading.innerText = "Image Preview"
  }
}

function closeModal() {
  var modal = document.getElementById("imageModal");

  // Check if the modal element is found
  if (modal) {
    modal.style.display = "none";
  }
}

function removeApplicationNo(filename){
  const fileNameArray = filename?.split('/')
  fileNameArray?.shift()
  let fileNameWithoutApplicationNo = fileNameArray?.join('/')
  return fileNameWithoutApplicationNo;
}


async function deleteFile(e,type = "la") {
  const deleteButton = e.target
  const previewImageContainer = deleteButton?.closest(".previewImageContainer")
  if (previewImageContainer){
    const image = previewImageContainer.querySelector(".preview-img")
    if (image){
      const filename = image.getAttribute('data-modal-filename')
      const doctype = image.getAttribute('data-modal-doctype')
      if (journeyState.applicationNo){
        const keyName = filename
        let res
        try {
          res = await deleteTempDocument({keyName})
        }catch(err){
          errorToastr('Could not delete file')
          return
        }
        try{
          const singleDoc = ["PHO","CNF","COC","DDI","ADD2","BDP"]
          successToastr(res?.msg)
          closeModal()
          if (!singleDoc.includes(doctype)){
            if (type === "la"){
              const tempResposneDocument = deepCopy(responseDocument)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setResponseDocument(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(uploadedDocuments)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setUploadedDocuments(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumber)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumber(tempDocNumberCount)
            }else if (type === "pr"){
              const tempResposneDocument = deepCopy(responseDocumentProposer)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setResponseDocumentProposer(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(documentPR)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setdocumentPR(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberProposer)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberProposer(tempDocNumberCount)
            }else if (type === "jl"){
              const tempResposneDocument = deepCopy(responseDocumentJointlife)
              const filteredResponse = tempResposneDocument[`_${doctype}_`]?.filter(tempDocument => tempDocument?.fileName !== '/' + removeApplicationNo(filename))
              tempResposneDocument[`_${doctype}_`] = filteredResponse
              setResponseDocumentJointlife(deepCopy(tempResposneDocument))
              const tempUploadDocuments = deepCopy(documentSA)
              const uploadFilteredResponse = tempUploadDocuments[`_${doctype}_`]?.filter(tempDocument => tempDocument?.location !== filename)
              tempUploadDocuments[`_${doctype}_`] = uploadFilteredResponse
              setdocumentSA(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberjointLife)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberjointLife(tempDocNumberCount)
            }

          }else{
            if (type === "la"){
              const tempResponseDocuments = deepCopy(responseDocument)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setResponseDocument(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(uploadedDocuments)
              tempUploadDocuments[`_${doctype}_`] = {
                path: "",
                name: "",
                location : "",
                msg: "",
              }
              setUploadedDocuments(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumber)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumber(tempDocNumberCount)
            }else if (type === "pr"){
              const tempResponseDocuments = deepCopy(responseDocumentProposer)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setResponseDocumentProposer(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(documentPR)
              tempUploadDocuments[`_${doctype}_`] = {
                filename: "",
                name: "",
                location : "",
                msg: "",
              }
              setdocumentPR(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberProposer)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberProposer(tempDocNumberCount)
            }else if (type === "jl"){
              const tempResponseDocuments = deepCopy(responseDocumentJointlife)
              tempResponseDocuments[`_${doctype}_`] = {
                location: "",
                fileName: "",
                msg: "",
              }
              setResponseDocumentJointlife(deepCopy(tempResponseDocuments))
              const tempUploadDocuments = deepCopy(documentSA)
              tempUploadDocuments[`_${doctype}_`] = {
                filename: "",
                name: "",
                location : "",
                msg: "",
              }
              setdocumentSA(deepCopy(tempUploadDocuments))
              const tempDocNumberCount = deepCopy(docNumberjointLife)
              tempDocNumberCount[`_${doctype}_`].count = tempDocNumberCount[`_${doctype}_`].count - 1;
              setDocNumberjointLife(tempDocNumberCount)
            }
          }
        }catch(err){
          console.info(err)
        }
      }
    }
  }
}

  const generateVCLink = async (e,linkOnly) => {
    e.preventDefault()
    if (vcTimerActive) {
      errorToastr(`Please wait ${vcTimeLeft} second${vcTimeLeft !== 1 ? "s" : ""} before trying again.`);
      return;
    }
    if(!linkOnly && !vcIdProof){// mandatory when proceed now
      errorToastr(`Please upload a valid ID proof first`);
      return;
    }

    // If PIVC is already completed, do not generate a new link.
    try {
      const pivcPayload = {
        WSO2Token: accessToken,
        application_no: journeyState.applicationNo,
      }
      const pivcRes = await getAnurPivcStatus(pivcPayload)
      if (pivcRes?.data?.PIVC_completed === "Y") {
        // Mark VC option as satisfied so document submit is allowed
        setVCOptionClicked(true)
        successToastr("Video Verification is completed")
        return
      }
    } catch (err) {
      // If status check fails, fall back to normal flow (allow link generation)
      console.error("Error while checking Anur PIVC status before generating VC link", err)
    }

    // As soon as user clicks Proceed Now with a valid ID proof,
    // treat video verification condition as satisfied (independent of API success).
    if (!linkOnly) {
      setVCOptionClicked(true);
    }
    setVCTimerActive(true);
    try {
      // For "Proceed Later", send null instead of actual file
      let formData = vcIdProof;
      if (linkOnly) {
        if (!formData?.has("image")) {
          const defaultWhiteImage = new FormData();
          /// Create a 1x1 white pixel image
          const whiteImageBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
          // Convert base64 to blob
          const byteString = atob(whiteImageBase64.split(',')[1]);
          const mimeString = whiteImageBase64.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], { type: mimeString });
          // Create FormData with white image
          defaultWhiteImage.append("image", blob, "default_white.png");
          formData = defaultWhiteImage;
          console.log("Image is attached.", formData);
        }
      }


      const data = await generateAnurVCLink({ journeyRef: journeyState.journeyId }, formData);
      if (!linkOnly && data.data?.link) {
        window.open(data.data?.link, "_blank");
      }

      successToastr("VC verification link has been sent to your registered email and mobile number");
      setVCOptionClicked(true);
    } catch (error) {
      setVCTimerActive(false); // Cancel timer immediately on error
      console.error(error)
      errorToastr(error?.response?.data?.message || error.message)
    }
  }
  return (
    <>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          
          /* Mobile layout fixes for this page:
             - prevent fixed-height upload cards from overlapping error text
             - remove negative heading margin that collides with errors
             - keep errors outside the upload box */
          @media (max-width: 767px){
            .upload-list{
              height: auto !important;
              min-height: 72px;
              position: relative;
              overflow: visible;
            }
            .upload-list-design{
              /* make room for error message below the box */
              margin-bottom: 56px !important;
            }
            .first-up-content{
              margin-top: 0px !important;
            }
            .file-inp-err{
              clear: both;
              /* render below the bordered upload box */
              position: absolute !important;
              top: 100% !important;
              left: 0 !important;
              right: 0 !important;
              padding-top: 8px !important;
              margin: 0 !important;
            }
            .file-inp-err .input-error,
            .file-inp-err label.error,
            .file-inp-err .text-danger{
              position: static !important;
              display: block !important;
              margin: 0 !important;
              line-height: 1.3;
              white-space: normal;
            }
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
          .choose-file-design{
              cursor:pointer;
          }
          .choose-file-design.pivc-disabled{
              cursor:not-allowed !important;
          }
          .choose-file-design.pivc-disabled:hover{
              background-color:#d3d3d3 !important;
          }

          .btn-disable{
              opacity:.5;
              pointer-events:none
          }
          .but-center-upload {
            clear: both;
            margin: 0px;
            padding: 14px;
            display: inline-block;
            width: 100%;
            text-align: center;
        }
          .elephant{
            display:flex;
            background:#dfdfdf;
            border:1px solid #ccc; 
            border-radius:4px;
            padding-right:.5rem;
            padding-bottom:.5rem;
          }

          .elephant img{
            position:relative;
            top:-2.5rem;
            left:-2.5rem;
          }

          .align-perfios-button{
            display:flex;
            justify-content:space-between;
          }
          .upload-img{
            display: flex;
            justify-content: space-between;
          }
          .upload-img img{
            width: 4rem;
            height: 4rem;
          }

          /* Unified preview overlay (works same for Upload + Capture) */
          .gainPreviewOverlay{
            position: fixed;
            inset: 0;
            z-index: 1000000;
            background: rgba(0,0,0,0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
          }
          .gainPreviewCard{
            width: 100%;
            max-width: 600px;
            max-height: calc(100dvh - 32px);
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.35);
            display: flex;
            flex-direction: column;
          }
          .gainPreviewHeader{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 12px 12px 16px;
            border-bottom: 1px solid #e9e9e9;
          }
          .gainPreviewTitle{
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #098CC5;
          }
          .gainPreviewClose{
            border: none;
            background: #000;
            color: #fff;
            width: 30px;
            height: 30px;
            border-radius: 999px;
            cursor: pointer;
            line-height: 30px;
          }
          .gainPreviewBody{
            padding: 12px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          }
          .gainPreviewBody img{
            width: 100%;
            height: auto;
            max-height: 60vh;
            object-fit: contain;
            display: block;
            background: #f4f4f4;
            border-radius: 10px;
            border: 1px solid #e6e6e6;
          }
          .gainPreviewFooter{
            padding: 12px 12px 16px;
            border-top: 1px solid #f0f0f0;
          }
          .gainPreviewFooter button{
            width: 100%;
            border: none;
            border-radius: 10px;
            padding: 12px 14px;
            font-weight: 600;
            background: #FEC32B;
            color: #fff;
          }

          

          .modal {
            display: none;
            position: fixed;
            z-index: 1000;
            padding-top: 100px;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            overflow: auto;
            background-color: rgba(0,0,0,0.9);
          }
          /* Modal Content */
          .modal-content {
            margin: auto;
            display: block;
            width: 100%;
            max-width: 700px;
          }
          /* Close button */
          .close {
            position: absolute;
            top: 15px;
            right: 35px;
            color: #f1f1f1;
            font-size: 40px;
            font-weight: bold;
            transition: 0.3s;
          }
          .close:hover,
          .close:focus {
            color: #bbb;
            text-decoration: none;
            cursor: pointer;
          }
          .anur{
            border:1px solid #cfcfcf;
            border-radius:10px;
            margin-top:45px !important;
          }
          @media (max-width: 600px){
          .anur{
            flex-direction:column;
          }
          .anur div{
              flex-direction: column;
              align-items: center;
              justify-content: center;
          }
          .anur > div > div{
              max-width:100% !important;
              width:100% !important;
          }
          .anur-button{
                width: 70%;
                padding: 10px !important;
          }

            
          }
        `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="iselect-box-design">
                <div className="heading-design">
                  <div className="iselect-padding left-side-head ckyc-w">
                    <h1 className="iselect-heading">Upload Documents</h1>
                  </div>
                  <div className="app-quatation nri-mt-space hidden-desktop-screen">
                    <div className="application-design-number">
                      Application Number: {journeyState.applicationNo}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 block" style={{ marginBottom: "30px", padding: "15px", backgroundColor: "#f8f9fa", display:"flex", flexDirection:"column", borderRadius: "4px", border: "1px solid #dee2e6" }}>
                  <p className="" style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px", display:"flex", flexDirection:"column" }}>
                    Document Upload Guidelines:
                  </p>
                  <ul style={{ paddingLeft: "25px", marginBottom: "0px", fontSize: "14px", lineHeight: "1.6" }}>
                    <li style={{ marginBottom: "8px" }}>
                      To continue with your insurance buying journey please upload pending requirement.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Please upload files (up to 5 documents, maximum size: 25MB each) in non-editable formats such as PDF, JPG, or PNG.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Please do not upload password protected file.
                    </li>
                    <li style={{ marginBottom: "0px" }}>
                      You can view or delete your uploaded documents any time before final submission.
                    </li>
                  </ul>
                </div>
                <form id="uploaddocument-form">
                  {
                    (anurConfigChannels.includes(props?.channel?.toUpperCase()) || ["EQUITAS", "equitas", "36"].includes(props?.channel)) &&
                    <>
                    <div className="col-md-12 flex-column my-4 p-3 anur">
                      {isPivcCompleted ? (
                        <div
                          className="d-flex align-items-center"
                          style={{
                            backgroundColor: "#5cb85c",
                            color: "#fff",
                            padding: "10px 14px",
                            borderRadius: "4px",
                            margin: "10px auto",
                            width: "fit-content",
                            gap: "10px",
                            fontWeight: 600,
                          }}
                          role="status"
                          aria-live="polite"
                        >
                          <span
                            aria-hidden="true"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "18px",
                              height: "18px",
                              borderRadius: "50%",
                              backgroundColor: "rgba(255,255,255,0.2)",
                              fontSize: "12px",
                              lineHeight: "18px",
                            }}
                          >
                            ✓
                          </span>
                          <span>Video Verification is completed</span>
                        </div>
                      ) : (
                        <>
                          <p className="fs-5 p-2 mb-0">
                            Video verification
                          </p>
                        <div className="col-md-12 d-flex gap-2">
                          <div className="col-md-12 my-3 d-flex gap-2" style={{maxWidth:"fit-content"}}>
                            <div className="justify-content-center d-flex align-items-center cen py-1 px-2 mx-0">
                              <label className={`choose-file-design ${isPivcCompleted ? "pivc-disabled" : ""}`} style={{ marginLeft: "10px" }}>
                                Upload ID Proof
                                <input
                                  type="file" svg
                                  accept="image/x-png,image/png,image/jpeg,image/tiff,image/bmp,image/webp,application/pdf"
                                  onChange={handleVCIdProofChange}
                                  disabled={isPivcCompleted}
                                  style={{ display: "none" }}
                                />
                              </label>
                            </div>
                            {vcIdProof && (
                              <div style={{ marginTop: "10px" }} className="d-flex align-items-center gap-2 justify-content-center flex-column mw-25">
                                {/* Optionally show preview */}
                                <img src={withPrefix("/images/upload2.png")} alt="ID Proof Preview" style={{ maxWidth: "70px", marginLeft: "10px" }} />
                                <span style={{ color: "green" }} className="text-truncate mw-100 " title={`${vcIdProofName}`}>{vcIdProofName}</span>
                              </div>
                            )}
                          </div>
                          <div className="d-flex flex-column gap-4 justify-content-center align-items-center my-auto ml-auto" style={{maxWidth:"fit-content"}}>
                            <div className="previous-btn cen py-2 px-5 mx-0 anur-button">
                              <button
                                name="start"
                                style={{ backgroundColor: "transparent", border: "none", borderRadius: "10px", color: "#fff" }}
                                disabled={!vcIdProof || vcTimerActive || isPivcCompleted}
                                onClick={(e) => {  generateVCLink(e,false) }}
                              >
                                Proceed Now
                              </button>
                            </div>
                            {!["EQUITAS", "equitas", "36"].includes(props?.channel) && (
                              <div className="previous-btn cen py-2 px-5 mx-0 anur-button">
                                <button

                                  name="share"
                                  style={{ backgroundColor: "transparent", border: "none", borderRadius: "10px", color: "#fff" }}
                                  onClick={(e) => { generateVCLink(e, true) }}
                                >
                                  Proceed Later
                                </button>
                              </div>)}
                          </div>
                        </div>
                        </>
                      )}
                    </div>
                    {submitted &&
                      (
                        (["EQUITAS", "equitas", "36"].includes(props?.channel) && isPivcPending) ||
                        (!["EQUITAS", "equitas", "36"].includes(props?.channel) && !vcOptionClicked)
                      ) &&
                      <p className="input-error">Please complete Video verification</p>
                    }
                    </>

                  }
                  <div className="col-md-12">
                    <div className="pension18 row">
                    {props?.channel !== "36" && (
                      <div className="col-md-6">
                        <div className="upload-list-design">
                        <p className="first-up-content">
                            Aadhaar Card of life assured{" "}
                            <span>
                              {" "}
                              (Upload front and back side of Aadhaar)
                            </span>
                          </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}  style={{
                                "position" : "relative"
                              }} >
                                <label
                                 
                                  className="choose-file-design"
                                  onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file2"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_UID_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableAadhar || disableAadhaarDL}
                                  />
                                </label>
                                {!(disabledMessageAadhar || disableAadhaarMessage) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery1 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disabledMessageAadhar || disableAadhaarMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img1">
                              {responseDocument?._UID_?.length > 1 ? responseDocument?._UID_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"UID"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload1.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}

                                  />
                                  )
                                }) : uploadedDocuments?._UID_?.length > 1 ? uploadedDocuments?._UID_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"UID"}
                                    data-name={doc?.name}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload1.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload1.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                             {submitted && responseDocument?._UID_?.length < 2 && uploadedDocuments?._UID_?.length < 2  && !disableAadhar && !disableAadhaarDL && props?.channel !== "36" && <p className="input-error" >Please upload Aadhaar Card</p>}
                            </div>
                            <div className="errormsg1 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      )}
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p className="">Capture a clear full‑length photo </p>
                          {/* <p className="first-up-content">
                            Photograph of Life Assured{" "}
                            <span>
                              {" "}
                              Latest within 3 month/ Upload full size Photograph
                            </span>
                          </p> */}
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                {/* <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFile(e, "_PHO_",true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <span></span> */}

                                <div className="choose-file-design" onClick={startCamera}>
                                  Capture
                                </div>

                              </div>

  
                              {showCamera && (
                                <div className="camera-overlay">
                                  <div className="camera-container">
                                    <video
                                      ref={videoRef}
                                      autoPlay
                                      playsInline
                                      muted
                                      className="camera-video"
                                    />
                                    <canvas ref={canvasRef} style={{ display: "none" }} />

                                    <div className="camera-actions">
                                      <button type="button" className="btn secondary" onClick={stopCamera}>
                                        Cancel
                                      </button>
                                      <button type="button" className="btn primary" onClick={capturePhoto}>
                                        Capture
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                  data-filename = {responseDocument._PHO_.fileName ? (journeyState.applicationNo +  responseDocument._PHO_.fileName) : uploadedDocuments?._PHO_?.location}
                                  className="upload-document-img"
                                  data-doctype = {"PHO"}
                                  doc-name = {responseDocument._PHO_.name || uploadedDocuments?._PHO_?.name || "Uploaded file"}
                                  src={
                                     responseDocument._PHO_.fileName
                                      ? isPdf(responseDocument._PHO_.fileName)
                                        ? pdfIcon
                                        : responseDocument._PHO_.location
                                      : uploadedDocuments?._PHO_?.name
                                      ? isPdf(uploadedDocuments._PHO_.name)
                                        ? pdfIcon
                                        : uploadedDocuments._PHO_.path
                                        : withPrefix("/images/upload1.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocument._PHO_.fileName || uploadedDocuments?._PHO_?.name){
                                     if (isPdf(responseDocument._PHO_.fileName || uploadedDocuments?._PHO_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !uploadedDocuments?._PHO_.name &&  !responseDocument._PHO_.fileName && <p className="input-error" >Please capture a clear full-length photo</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>ID Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }} >
                                <label

                                  className="choose-file-design"
                                  onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file2"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_IDP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableIDP || (disable && !isLifeAssuredCkycOptional)}
                                  />
                                </label>
                                {(!disableIDPmessage && (!disabledMessage || isLifeAssuredCkycOptional)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery1 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableIDP ? disableIDPmessage :disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img1">
                              {responseDocument?._IDP_?.length > 1 ? responseDocument?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._IDP_?.length > 1 ? uploadedDocuments?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"IDP"}
                                    data-name={doc?.name}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload2.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload2.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._IDP_?.length < 2 && responseDocument?._IDP_?.length < 2 && !disable && !disableIDP && <p className="input-error" >Please upload ID Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg1 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 ">
                        <div className="upload-list-design">
                          <p>Income Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}  style={{
                                "position" : "relative"
                              }} >
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file3')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file3"
                                    name="file2"
                                    multiple
                                    onInput={e => uploadFile(e, "_SOW_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />
                              </div>
                              <div className="gallery2 upload-img"> </div>
                              <div className="upload-img icon-img2">
                              {responseDocument?._SOW_?.length > 1 ? responseDocument?._SOW_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"SOW"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload3.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._SOW_?.length > 1 ? uploadedDocuments?._SOW_?.slice(1).map(doc => {
                                  
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"SOW"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload3.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload3.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._SOW_?.length < 2 && responseDocument?._SOW_?.length < 2 && <p className="input-error">Please upload Income Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg2 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Current Address Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFile(e, "_CAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable || addressProceedPermanent}
                                    disabled={disableADP || (disable && !addressProceedPermanent && !isLifeAssuredCkycOptional)}
                                  />
                                </label>
                                {!(disableADPmessage || (!addressProceedPermanent && disabledMessage && !isLifeAssuredCkycOptional)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableADP ? disableADPmessage :!addressProceedPermanent && disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocument?._CAP_?.length > 1 ? responseDocument?._CAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._CAP_?.length > 1 ? uploadedDocuments?._CAP_?.slice(1).map(doc => {
                                 
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._PAP_?.length < 2 && uploadedDocuments?._CAP_?.length < 2 && responseDocument?._CAP_?.length < 2 && responseDocument?._PAP_?.length < 2 && !(!addressProceedPermanent && disabledMessage) && <p className="input-error">Please upload Current Address Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      { allJourneyData?.lifeAssuredDetails?.communicationDetails?.sameAsCurrentAddress === "N" &&
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Permanent Address Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFile(e, "_PAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable || addressProceedPermanent}
                                    disabled={disablePermanentAddress && !isLifeAssuredCkycOptional}
                                  />
                                </label>
                               {(!permanentAddressDisableMessage || isLifeAssuredCkycOptional) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />} 
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {permanentAddressDisableMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocument?._PAP_?.length > 1 ? responseDocument?._PAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._PAP_?.length > 1 ? uploadedDocuments?._PAP_?.slice(1).map(doc => {
                                 
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._PAP_?.length < 2 && uploadedDocuments?._CAP_?.length < 2 && responseDocument?._CAP_?.length < 2 && responseDocument?._PAP_?.length < 2 && !(disablePermanentAddress) && <p className="input-error">Please upload Permanent Address Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                       }
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Age Proof of Life Assured </p>
                          <div className="upload-list">
                            <div>
                              {/* <div className={isUploading ? "btn-disable" : ""}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file5')}
                                >
                                  {" "}
                                  Download
                                  <input
                                    type="file"
                                    id="file5"
                                    name="file4"
                                    multiple
                                    // onInput={e => uploadFile(e, "_AGP_")}
                                    onClick={(e,)=>documentDownload(e,"_AGP_")}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disable}
                                  />
                                </label>
                              </div> */}
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file5')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file5"
                                    name="file4"
                                    multiple
                                    onInput={e => uploadFile(e, "_AGP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableAGP || (disable && !isLifeAssuredCkycOptional)}
                                  />
                                </label>
                               {(!disableAGPmessage && (!disabledMessage || isLifeAssuredCkycOptional)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />} 
                              </div>
                              <div className="gallery4 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {disableAGP ? disableAGPmessage : disabledMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img4">
                              {responseDocument?._AGP_?.length > 1 ? responseDocument?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : uploadedDocuments?._AGP_?.length > 1 ? uploadedDocuments?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                    
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload5.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && uploadedDocuments?._AGP_?.length < 2 && responseDocument._AGP_.length < 2 && !disable && !disableAGP && <p className="input-error">Please upload Age Proof of Life Assured</p>}
                            </div>
                            <div className="errormsg4 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>ID Proof of Proposer </p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label

                                    className="choose-file-design"
                                    onKeyPress={(event) => handleFileEnter(event, 'file2')} tabIndex="0"
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file2"
                                      name="file2"
                                      multiple
                                      onInput={e => uploadFileForProposer(e, "_IDP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                      // required
                                      // required={!disable}
                                      disabled={disableIDPPR || (disableProposer && !isProposerCkycOptional)}
                                    />
                                  </label>
                                 {(!disableIDPPRmessage && (!disabledMessageProposer || isProposerCkycOptional)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />} 
                                </div>
                                <div className="gallery1 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableIDPPR ? disableIDPPRmessage :disabledMessageProposer}
                                  </span>
                                </div>
                                <div className="upload-img icon-img1">
                                {responseDocumentProposer?._IDP_?.length > 1 ? responseDocumentProposer?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._IDP_?.length > 1 ? documentPR?._IDP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"IDP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload5.png")}
                              />}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {submitted && documentPR?._IDP_?.length < 2 && responseDocumentProposer._IDP_.length < 2 && !(disableProposer || disableProposerPermanentAddress) && !disableIDPPR && <p className="input-error" >Please upload ID Proof of Proposer</p>}
                              </div>
                              <div className="errormsg1 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>Current address proof of Proposer</p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file4"
                                      name="file3"
                                      multiple
                                      onInput={e => uploadFileForProposer(e, "_CAP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                      // required
                                      // required={!disable || addressProceedPermanent}
                                      disabled={disableADPPR || (disableProposer && addressProceedPermanentProposer && !isProposerCkycOptional)}
                                    />
                                  </label>
                                 {!(disableADPPRmessage || (addressProceedPermanentProposer && disabledMessageProposer && !isProposerCkycOptional)) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />} 
                                </div>
                                <div className="gallery3 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableADPPR ? disableADPPRmessage : addressProceedPermanentProposer && disabledMessageProposer}
                                  </span>
                                </div>
                                <div className="upload-img icon-img3">
                                {responseDocumentProposer?._CAP_?.length > 1 ? responseDocumentProposer?._CAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._CAP_?.length > 1 ? documentPR?._CAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"CAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                   
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {submitted && documentPR?._PAP_?.length < 2 && documentPR?._CAP_?.length < 2 && responseDocumentProposer?._CAP_?.length < 2 && responseDocumentProposer?._PAP_?.length < 2 && !(disabledMessageProposer) && <p className="input-error">Please upload  current address proof of proposer</p>}
                              </div>
                              <div className="errormsg3 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                       { allJourneyData?.proposerDetails?.communicationDetails?.sameAsCurrentAddress === "N" && 
                        <div className="col-md-6">
                        <div className="upload-list-design">
                          <p>Permanent address proof of Proposer </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file4')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file4"
                                    name="file3"
                                    multiple
                                    onInput={e => uploadFileForProposer(e, "_PAP_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    disabled={disableProposerPermanentAddress && !isProposerCkycOptional}
                                  />
                                </label>
                                {(!permanentProposerAddressDisableMessage || isProposerCkycOptional) && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />}
                              </div>
                              <div className="gallery3 upload-img"> </div>
                              <div style={{ display: "flex", float: "left" }}>
                                <span
                                  style={{
                                    color: "orange",
                                    fontSize: "20px",
                                    marginLeft: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {permanentProposerAddressDisableMessage}
                                </span>
                              </div>
                              <div className="upload-img icon-img3">
                              {responseDocumentProposer?._PAP_?.length > 1 ? responseDocumentProposer?._PAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentPR?._PAP_?.length > 1 ? documentPR?._PAP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"PAP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="pr"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload4.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}
                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload4.png")}
                              />}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {submitted && documentPR?._PAP_?.length < 2 && documentPR?._CAP_?.length < 2 && responseDocumentProposer?._CAP_?.length < 2 && responseDocumentProposer?._PAP_?.length < 2 && !(disableProposerPermanentAddress) && <p className="input-error">Please upload permanent address proof of proposer</p>}
                            </div>
                            <div className="errormsg3 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      }
                      {(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" && (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney")) &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>Age Proof of Joint Life </p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""} style={{
                                "position" : "relative"
                              }}>
                                  <label

                                    className="choose-file-design"
                                    onKeyPress={(event) => handleFileEnter(event, 'file10')} tabIndex="0"
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file10"
                                      name="file10"
                                      multiple
                                      onInput={e => uploadFileForJointlife(e, "_AGP_",true)}
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    // required={!disable}
                                    disabled={disableAGPSA}
                                    />
                                  </label>
                                 {!disableAGPSAmessage && <img style={{
                                  width : "30px",
                                  position : "absolute",
                                  top : "20px",
                                  left : "170px"
                                }} src={withPrefix('images/plus-image.png')} alt="" />} 
                                </div>
                                <div className="gallery1 upload-img"> </div>
                                <div style={{ display: "flex", float: "left" }}>
                                  <span
                                    style={{
                                      color: "orange",
                                      fontSize: "20px",
                                      marginLeft: "20px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {disableAGPSAmessage}
                                  </span>
                                </div>
                                <div className="upload-img icon-img3">
                                {responseDocumentJointlife?._AGP_?.length > 1 ? responseDocumentJointlife?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    data-filename = {journeyState.applicationNo +  doc.fileName}
                                    className="upload-document-img"
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="jl"
                                    src={
                                      doc?.fileName
                                        ? isPdf(doc?.fileName)
                                          ? pdfIcon
                                          : doc.location
                                        : withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) =>  {
                                      if (doc?.fileName){
                                       if (isPdf(doc.fileName)){
                                         openModal(e.target,"pdf")
                                       }else{
                                         openModal(e.target,"img")
                                       }
                                      }
                                   }}
                                  />
                                  )
                                }) : documentSA?._AGP_?.length > 1 ? documentSA?._AGP_?.slice(1).map(doc => {
                                  return (
                                    <img
                                    className="upload-document-img"
                                    data-filename = {doc.location}
                                    data-doctype = {"AGP"}
                                    data-name = {doc?.name || "Uploaded file"}
                                    data-type="jl"
                                    src={
                                      doc?.name
                                        ? isPdf(doc?.name)
                                          ? pdfIcon
                                          : doc?.path
                                          :  withPrefix("/images/upload5.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (doc?.name){
                                        if (isPdf(doc.name)){
                                          openModal(e.target,"pdf")
                                        }else{
                                          openModal(e.target,"img")
                                        }
                                       }
                                    }}

                                  />
                                  )
                                }) : <img
                                className="upload-document-img"
                                src={ withPrefix("/images/upload5.png")}
                              />}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {submitted && documentSA?._AGP_?.length < 2 && responseDocumentJointlife._AGP_?.length < 2 && disableJointlife && <p className="input-error" >Please upload Age Proof of Joint Life </p>}
                              </div>
                              <div className="errormsg1 clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      { allJourneyData?.journeyType?.toLowerCase() === "canarapos" && <div className="col-md-6">
                          <div className="upload-list-design">
                          <p>Consent Form</p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label
                                  disabled={isUploading}
                                  className="choose-file-design"
                                  tabIndex="0"
                                  onKeyPress={(event) => handleFileEnter(event, 'file6')}
                                >
                                  {" "}
                                  Upload
                                  <input
                                    type="file"
                                    id="file6"
                                    name="file5"
                                    multiple
                                    onInput={e => uploadFile(e, "_CNF_",true)}
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  />
                                </label>
                              </div>
                              <div className="gallery5 upload-img"> </div>
                              <div className="upload-img icon-img5">
                                {" "}
                                <img
                                data-filename = {responseDocument._CNF_.fileName ? (journeyState.applicationNo +  responseDocument._CNF_.fileName) : uploadedDocuments?._CNF_?.location}
                                className="upload-document-img"
                                data-doctype = {"CNF"}
                                data-name = {responseDocument._CNF_.name || uploadedDocuments?._CNF_?.name || "Uploaded file"}
                                  src={
                                     responseDocument._CNF_.fileName
                                      ? isPdf(responseDocument._CNF_.fileName)
                                        ? pdfIcon
                                        : responseDocument._CNF_.location
                                      : uploadedDocuments?._CNF_?.name
                                      ? isPdf(uploadedDocuments._CNF_.name)
                                        ? pdfIcon
                                        : uploadedDocuments._CNF_.path
                                        : withPrefix("/images/upload51.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocument._CNF_.fileName || uploadedDocuments?._CNF_?.name){
                                     if (isPdf(responseDocument._CNF_.fileName || uploadedDocuments?._CNF_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="errormsg5 clearfixerror"></div>
                          </div>
                        </div>
                      </div>}
                      {(paymentMethod === "cheque" && allJourneyData?.basicDetails.channel === "A") &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>Cheque Image</p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""}>
                                  <label className="choose-file-design">
                                    Upload
                                    <input
                                      type="file"
                                      id="file"
                                      name="file"
                                      multiple
                                      onInput={e => uploadFile(e, "_COC_", true)}
                                      onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    />
                                  </label>
                                  <span></span>
                                </div>
                                <div className="gallery"> </div>
                                <div className="upload-img icon-img">
                                  {" "}
                                  <img
                                    data-filename={responseDocument._COC_.fileName ? (journeyState.applicationNo + responseDocument._COC_.fileName) : uploadedDocuments?._COC_?.location}
                                    className="upload-document-img"
                                    data-doctype={"COC"}
                                    data-name={responseDocument._COC_.name || uploadedDocuments?._COC_?.name || "Uploaded file"}
                                    src={
                                      responseDocument._COC_.fileName
                                        ? isPdf(responseDocument._COC_.fileName)
                                          ? pdfIcon
                                          : responseDocument._COC_.location
                                        : uploadedDocuments?._COC_?.name
                                          ? isPdf(uploadedDocuments._COC_.name)
                                            ? pdfIcon
                                            : uploadedDocuments._COC_.path
                                          : withPrefix("/images/upload7.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (responseDocument._COC_.fileName || uploadedDocuments?._COC_?.name) {
                                        if (isPdf(responseDocument._COC_.fileName || uploadedDocuments?._COC_?.name)) {
                                          openModal(e.target, "pdf")
                                        } else {
                                          openModal(e.target, "img")
                                        }
                                      }
                                    }}
                                  />{" "}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {
                                  submitted && !uploadedDocuments?._COC_?.name && !responseDocument._COC_.fileName && <p className="input-error" >Please upload Cheque Image</p>
                                }
                              </div>
                              <div className="errormsg clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      {(paymentMethod === "dd" && allJourneyData?.basicDetails.channel === "A") &&
                        <div className="col-md-6">
                          <div className="upload-list-design">
                            <p>Demand Draft Image</p>
                            <div className="upload-list">
                              <div>
                                <div className={isUploading ? "btn-disable" : ""}>
                                  <label className="choose-file-design">
                                    Upload
                                    <input
                                      type="file"
                                      id="file"
                                      name="file"
                                      multiple
                                      onInput={e => uploadFile(e, "_DDI_", true)}
                                      onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                      accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                    // required
                                    />
                                  </label>
                                  <span></span>
                                </div>
                                <div className="gallery"> </div>
                                <div className="upload-img icon-img">
                                  {" "}
                                  <img
                                    data-filename={responseDocument._DDI_.fileName ? (journeyState.applicationNo + responseDocument._DDI_.fileName) : uploadedDocuments?._DDI_?.location}
                                    className="upload-document-img"
                                    data-doctype={"DDI"}
                                    data-name={responseDocument._DDI_.name || uploadedDocuments?._DDI_?.name || "Uploaded file"}
                                    src={
                                      responseDocument._DDI_.fileName
                                        ? isPdf(responseDocument._DDI_.fileName)
                                          ? pdfIcon
                                          : responseDocument._DDI_.location
                                        : uploadedDocuments?._DDI_?.name
                                          ? isPdf(uploadedDocuments._DDI_.name)
                                            ? pdfIcon
                                            : uploadedDocuments._DDI_.path
                                          : withPrefix("/images/upload7.png")
                                    }
                                    aria-hidden="true"
                                    onClick={(e) => {
                                      if (responseDocument._DDI_.fileName || uploadedDocuments?._DDI_?.name) {
                                        if (isPdf(responseDocument._DDI_.fileName || uploadedDocuments?._DDI_?.name)) {
                                          openModal(e.target, "pdf")
                                        } else {
                                          openModal(e.target, "img")
                                        }
                                      }
                                    }}
                                  />{" "}
                                </div>
                              </div>
                              <div className="file-inp-err" >
                                {
                                  submitted && !uploadedDocuments?._DDI_?.name && !responseDocument._DDI_.fileName && <p className="input-error" >Please upload Demand Draft Image</p>
                                }
                              </div>
                              <div className="errormsg clearfixerror"></div>
                            </div>
                          </div>
                        </div>
                      }
                      <div className="col-md-6">
                      <div className="upload-list-design">
                          <p>Fetch bank statement via finarkein</p>
                          <div className="upload-list">
                            <div>
                            <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    style={{
                                      border: "none",
                                    }}
                                    onKeyPress={(event) => handleNavigateFinarkein()}
                                    onClick={handleNavigateFinarkein}
                                  >
                                    {" "}
                                    Proceed
                                  </label>
                                </div>
                              <div className="gallery5 upload-img"> </div>
                              <div className="upload-img icon-img5">
                                {" "}
                                <img
                                  src={
                                      withPrefix("/images/upload3.png")
                                  }
                                />{" "}
                              </div>
                            </div>
                            <div className="errormsg5 clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" &&
                      <div className="col-md-6">
                        <div className="upload-list-design">
                          <p className="first-up-content">
                            Photograph of Proposer{" "}
                            <span>
                              {" "}
                              Latest within 3 month/ Upload full size Photograph
                            </span>
                          </p>
                          <div className="upload-list">
                            <div>
                              <div className={isUploading ? "btn-disable" : ""}>
                                <label className="choose-file-design">
                                  Upload
                                  <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    multiple
                                    onInput={e => uploadFileForProposer(e, "_PHO_",true)}
                                    onKeyPress={(event) => handleFileEnter(event, 'file1')} tabIndex="0"
                                    accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                  // required
                                  />
                                </label>
                                <span></span>
                              </div>
                              <div className="gallery"> </div>
                              <div className="upload-img icon-img">
                                {" "}
                                <img
                                data-filename = {responseDocumentProposer._PHO_.fileName ? (journeyState.applicationNo +  responseDocumentProposer._PHO_.fileName) : documentPR?._PHO_?.location}
                                className="upload-document-img"
                                data-doctype = {"PHO"}
                                data-type="pr"
                                doc-name = {responseDocumentProposer._PHO_.name || documentPR?._PHO_?.name || "Uploaded file"}
                                  src={
                                     responseDocumentProposer._PHO_.fileName
                                      ? isPdf(responseDocumentProposer._PHO_.fileName)
                                        ? pdfIcon
                                        : responseDocumentProposer._PHO_.location
                                      : documentPR?._PHO_?.name
                                      ? isPdf(documentPR._PHO_.name)
                                        ? pdfIcon
                                        : documentPR._PHO_.path
                                        : withPrefix("/images/upload1.png")
                                  }
                                  aria-hidden="true"
                                  onClick={(e) =>  {
                                    if (responseDocumentProposer._PHO_.fileName || documentPR?._PHO_?.name){
                                     if (isPdf(responseDocumentProposer._PHO_.fileName || documentPR?._PHO_?.name)){
                                       openModal(e.target,"pdf")
                                     }else{
                                       openModal(e.target,"img")
                                     }
                                    }
                                 }}
                                />{" "}
                              </div>
                            </div>
                            <div className="file-inp-err" >
                              {
                                submitted && !documentPR?._PHO_.name &&  !responseDocumentProposer._PHO_.fileName && <p className="input-error" >Please upload Photograph of Proposer</p>
                              }
                            </div>
                            <div className="errormsg clearfixerror"></div>
                          </div>
                        </div>
                      </div>
                      }
                      {effectiveRequiredDocs.length > 0 && 
                        effectiveRequiredDocs.map((docCode, index) => {
                          const docType = getDocTypeFromGridCode(docCode)
                          const needsDropdown = shouldShowDropdown(docCode)
                          const selectedOption = selectedIncomeProofOptions[docType]
                          // Use lookup for display name (e.g. FINANCIAL_SOW -> Source of Wealth), else format from code
                          const docDisplayName = lookup?.docDisplayName?.[docCode] ?? docCode
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ')
                          
                          return (
                            <div key={docCode} className="col-md-6">
                              <div className="upload-list-design">
                                <p>{docDisplayName}</p>
                                <div className="upload-list" style={needsDropdown ? { paddingTop: "0px" , paddingRight: "0px"} : {}}>
                                  <div>
                                    {needsDropdown ? (
                                      <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px" }}>
                                        <div style={{ width: "50%" }}>
                                          <SelectContainer needsDropdown={needsDropdown}>
                                            <label>Select Type</label>
                                            <Select
                                              options={Object.entries(docGridData?.incomeProofDocs || {}).map(([key, value]) => ({
                                                value: key,
                                                label: value
                                              }))}
                                              name={`incomeProofSelect_${docCode}`}
                                              value={selectedOption ? { value: selectedOption, label: docGridData?.incomeProofDocs?.[selectedOption] || selectedOption } : null}
                                              onChange={(option) => {
                                                setSelectedIncomeProofOptions(prev => ({
                                                  ...prev,
                                                  [docType]: option?.value || null
                                                }))
                                              }}
                                              placeholder="Select type"
                                            />
                                          </SelectContainer>
                                        </div>
                                        <div className={isUploading ? "btn-disable" : ""} style={{
                                          "position": "relative",
                                          "flex": "0 0 auto"
                                        }}>
                                          <label
                                            className="choose-file-design"
                                            onKeyPress={(event) => handleFileEnter(event, `docGrid_${docCode}`)} 
                                            tabIndex="0"
                                          >
                                            {" "}
                                            Upload
                                            <input
                                              type="file"
                                              id={`docGrid_${docCode}`}
                                              name={`docGrid_${docCode}`}
                                              multiple
                                              onInput={e => uploadFile(e, docType, true, selectedOption)}
                                              accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                              disabled={isUploading || !selectedOption}
                                            />
                                          </label>
                                          {selectedOption && (
                                            <img style={{
                                              width: "30px",
                                              position: "absolute",
                                              top: "20px",
                                              left: "170px"
                                            }} src={withPrefix('images/plus-image.png')} alt="" />
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className={isUploading ? "btn-disable" : ""} style={{
                                        "position": "relative"
                                      }}>
                                        <label
                                          className="choose-file-design"
                                          onKeyPress={(event) => handleFileEnter(event, `docGrid_${docCode}`)} 
                                          tabIndex="0"
                                        >
                                          {" "}
                                          Upload
                                          <input
                                            type="file"
                                            id={`docGrid_${docCode}`}
                                            name={`docGrid_${docCode}`}
                                            multiple
                                              onInput={e => uploadFile(e, docType, true, selectedOption)}
                                            accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                            disabled={isUploading}
                                          />
                                        </label>
                                        <img style={{
                                          width: "30px",
                                          position: "absolute",
                                          top: "20px",
                                          left: "170px"
                                        }} src={withPrefix('images/plus-image.png')} alt="" />
                                      </div>
                                    )}
                                    <div className="gallery1 upload-img"> </div>
                                    {!needsDropdown && (
                                    <div className="upload-img icon-img1">
                                      {responseDocument?.[docType]?.length > 1 ? responseDocument?.[docType]?.slice(1).map((doc, docIndex) => {
                                        return (
                                          <img
                                            key={docIndex}
                                            data-filename={journeyState.applicationNo + doc.fileName}
                                            className="upload-document-img"
                                            data-doctype={docType.replace(/_/g, '')}
                                            data-name={doc?.name || "Uploaded file"}
                                            src={
                                              doc?.fileName
                                                ? isPdf(doc?.fileName)
                                                  ? pdfIcon
                                                  : doc.location
                                                : withPrefix("/images/upload2.png")
                                            }
                                            aria-hidden="true"
                                            onClick={(e) => {
                                              if (doc?.fileName) {
                                                if (isPdf(doc.fileName)) {
                                                  openModal(e.target, "pdf")
                                                } else {
                                                  openModal(e.target, "img")
                                                }
                                              }
                                            }}
                                          />
                                        )
                                      }) : uploadedDocuments?.[docType]?.length > 1 ? uploadedDocuments?.[docType]?.slice(1).map((doc, docIndex) => {
                                        return (
                                          <img
                                            key={docIndex}
                                            className="upload-document-img"
                                            data-filename={doc.location}
                                            data-doctype={docType.replace(/_/g, '')}
                                            data-name={doc?.name || "Uploaded file"}
                                            src={
                                              doc?.name
                                                ? isPdf(doc?.name)
                                                  ? pdfIcon
                                                  : doc?.path
                                                  : withPrefix("/images/upload2.png")
                                            }
                                            aria-hidden="true"
                                            onClick={(e) => {
                                              if (doc?.name) {
                                                if (isPdf(doc.name)) {
                                                  openModal(e.target, "pdf")
                                                } else {
                                                  openModal(e.target, "img")
                                                }
                                              }
                                            }}
                                          />
                                        )
                                      }) : (
                                        <img
                                          className="upload-document-img"
                                          src={withPrefix("/images/upload2.png")}
                                        />
                                      )}
                                    </div>
                                    )}
                                    {needsDropdown && (
                                      <div className="upload-img icon-img1">
                                        {responseDocument?.[docType]?.length > 1 ? responseDocument?.[docType]?.slice(1).map((doc, docIndex) => {
                                          return (
                                            <img
                                              key={docIndex}
                                              data-filename={journeyState.applicationNo + doc.fileName}
                                              className="upload-document-img"
                                              data-doctype={docType.replace(/_/g, '')}
                                              data-name={doc?.name || "Uploaded file"}
                                              src={
                                                doc?.fileName
                                                  ? isPdf(doc?.fileName)
                                                    ? pdfIcon
                                                    : doc.location
                                                  : withPrefix("/images/upload2.png")
                                              }
                                              aria-hidden="true"
                                              onClick={(e) => {
                                                if (doc?.fileName) {
                                                  if (isPdf(doc.fileName)) {
                                                    openModal(e.target, "pdf")
                                                  } else {
                                                    openModal(e.target, "img")
                                                  }
                                                }
                                              }}
                                            />
                                          )
                                        }) : uploadedDocuments?.[docType]?.length > 1 ? uploadedDocuments?.[docType]?.slice(1).map((doc, docIndex) => {
                                          return (
                                            <img
                                              key={docIndex}
                                              className="upload-document-img"
                                              data-filename={doc.location}
                                              data-doctype={docType.replace(/_/g, '')}
                                              data-name={doc?.name || "Uploaded file"}
                                              src={
                                                doc?.name
                                                  ? isPdf(doc?.name)
                                                    ? pdfIcon
                                                    : doc?.path
                                                  : withPrefix("/images/upload2.png")
                                              }
                                              aria-hidden="true"
                                              onClick={(e) => {
                                                if (doc?.name) {
                                                  if (isPdf(doc.name)) {
                                                    openModal(e.target, "pdf")
                                                  } else {
                                                    openModal(e.target, "img")
                                                  }
                                                }
                                              }}
                                            />
                                          )
                                        }) : (
                                          <img
                                            className="upload-document-img"
                                            src={withPrefix("/images/upload2.png")}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  <div className="file-inp-err">
                                    {submitted && (responseDocument?.[docType]?.length < 2 && uploadedDocuments?.[docType]?.length < 2) && needsDropdown && !selectedOption && (
                                      <p className="input-error">Please select income proof type first</p>
                                    )}
                                    {submitted && (responseDocument?.[docType]?.length < 2 && uploadedDocuments?.[docType]?.length < 2) && (
                                      <p className="input-error">Please upload {docDisplayName}</p>
                                    )}
                                  </div>
                                  <div className="errormsg1 clearfixerror"></div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                      <div className="col-md-6">
                      {/* <div className="upload-list-design">
                          <p>Account Details of Life Assured </p>
                          <div
                            className="upload-list"
                            style={{ height: "initial" }}
                          >
                            <div className="uprow elephant">
                              <img
                                src={withPrefix("/images/piggi-bank.png")}
                                style={{ borderRadius: "50%" }}
                              />
                              <span>
                                Account Details of Life Assured (where
                                refund/policy payout to made)- (Cancelled cheque/
                                Passbook/latest bank account statement)
                              </span>
                            </div>
                              
                            <div>
                              <span style={{ marginTop: "2rem" }}>
                                Please choose Net Banking or Statement option in
                                case you want to upload document via Perfios
                              </span>
                              <form>
                                <input
                                  type="radio"
                                  name="perfiosUploadDocument1"
                                  id="uploadDocument1"
                                  onChange={changeBankingOption}
                                  onKeyPress={handleChangeBankingOption}
                                  value="netbankingFetch"
                                  tabIndex="0"
                                />
                                <label
                                  htmlFor="uploadDocument1"
                                  style={{
                                    marginRight: "1rem",
                                  }}
                                >
                                  Net Banking via Perfios
                                </label>

                                <input
                                  type="radio"
                                  name="perfiosUploadDocument1"
                                  id="uploadDocument2"
                                  onChange={changeBankingOption}
                                  onKeyPress={handleChangeBankingOption}
                                  value="statement"
                                  tabIndex="0"
                                />
                                <label htmlFor="uploadDocument2">
                                  Bank Statement Upload via Perfios
                                </label>
                              </form>
                            </div>
                            {errorState && (
                              <label className="input-error error">{errorState}</label>
                            )}

                            <div>
                              <div className="align-perfios-button">
                                <p>
                                  Upload latest bank account statement through
                                  Perfios
                                </p>
                                <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    style={{
                                      background: "transparent",
                                      height: "62px",
                                      paddingTop: 0,
                                    }}
                                    onKeyPress={(event) => handlePerfiosEnter(event)}
                                  >
                                    {" "}
                                    <button
                                      type="button"
                                      style={{ backgroundColor: "white" }}
                                      onClick={navigateToPerfiosUrl}
                                    >
                                      <img src={withPrefix("/images/perf-img.png")} />
                                    </button>
                                  </label>
                                </div>
                              </div>
                              <span style={{ marginLeft: "14rem" }}>OR</span>
                              <div className="align-perfios-button">
                                <p style={{ marginLeft: "6rem" }}>
                                  Upload documents manually
                                </p>
                                <div
                                  className={isUploading ? "btn-disable" : ""}
                                >
                                  <label
                                    disabled={isUploading}
                                    className="choose-file-design"
                                    tabIndex="0"
                                    onKeyPress={(event) => handleFileEnter(event, 'file7')}
                                  >
                                    {" "}
                                    Upload
                                    <input
                                      type="file"
                                      id="file7"
                                      name="file7"
                                      multiple
                                      onInput={e =>
                                        navigateToPerfiosUrl(e, "_BAS_")
                                      }
                                      accept="image/x-png,application/pdf,image/jpeg"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="gallery7 upload-img"> </div>
                            <div className="errormsg7 clearfixerror"></div>
                          </div>
                      </div> */}
                      </div>
                    </div>
                  </div>
                  {retreiveUploadedDocumentsData?.length > 0 && 
                  <div>
                    <h3>Please Download & Upload the journey Documents</h3>
                  {/* {
                    retreiveUploadedDocumentsData?.map((element, i)=> {
                      return(
                      <UploadDocumentsSigned key={i} data={element}/>
                    )
                    })           
                  } */}
                  <div>
                    <SelectContainer>
                      <label >Please Select the Document</label>
                      <Select
                        options={docOptions}
                        name="Select"
                        key="Select"
                        id="InputSelect"
                        required={true}
                        tabIndex={-1}
                        value={selectedOption ? getKeyByValue(selectedOption, docOptions) : ""}
                        onChange={e => handleChange(e, retreiveUploadedDocumentsData)}
                      ></Select>
                    </SelectContainer>
                    { selectedOption &&
                    <div>
                      <div className="col-md-12">
                        <div className="pension18 row">
                          <div className="col-md-12">
                            <div className="upload-list-design">
                              {/* <p>{Description}</p> */}
                              <div className="upload-list">
                                <div>
                                  <div className={isUploading ? "btn-disable" : ""}>
                                    <div >
                                      <label style={{marginRight:"10px"}}
                                        className="choose-file-design"
                                        onKeyPress={event => handleFileEnter(event, "file2")}
                                        tabIndex="0"
                                      >
                                        {" "}
                                        Download
                                        <input
                                          type="file"
                                          id="file2"
                                          name="file2"
                                          multiple
                                          // onInput={e => uploadFile(e, "_ADE_")}
                                          accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                          // required
                                          // required={!disable}
                                          onClick={e => downloadFile(e, selectedOptionData?.location)}
                                        />
                                      </label>
                                    </div>
                                    <div >
                                      <label style={{marginRight:"10px", marginLeft:"10px"}}
                                        className="choose-file-design"
                                        onKeyPress={event => handleFileEnter(event, "file2")}
                                        tabIndex="0"
                                      >
                                        {" "}
                                        Print
                                        <input
                                          type="file"
                                          id="file2"
                                          name="file2"
                                          multiple
                                          // onInput={e => uploadFile(e, "_ADE_")}
                                          accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                          // required
                                          // required={!disable}
                                          onClick={e => printFile(e, selectedOptionData?.location)}
                                        />
                                      </label>
                                    </div>
                                    <div >
                                      <label style={{marginLeft:"10px"}}
                                        className="choose-file-design"
                                        onKeyPress={event => handleFileEnter(event, "file2")}
                                        tabIndex="0"
                                      >
                                        {" "}
                                        Upload
                                        <input
                                          type="file"
                                          id="file2"
                                          name="file2"
                                          multiple
                                          onInput={e => uploadFile(e, selectedOptionData?.fileCode)}
                                          accept="image/x-png,application/pdf,image/jpeg, image/tiff"
                                          // required
                                          // required={!disable}
                                        />
                                      </label>
                                    </div>
                                  </div>
                                  {/* <div className="gallery1 upload-img"> </div> */}
                                  <div className="upload-img icon-img1">
                                    {" "}
                                    <img
                                      // src={ withPrefix("/images/upload51.png")
                                      src={
                                          responseDocument[selectedOptionData?.fileCode]
                                              ? pdfIcon
                                            : withPrefix("/images/upload51.png")
                                        }
                                      // }
                                    />{" "}
                                  </div>
                                </div>
                                <div className="errormsg1 clearfixerror"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  </div>
                  }
                </form>
                <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={digilockerLA ? {
                            background : "gray",
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            cursor : "not-allowed"
                          } : {
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                          }}
                          disabled={digilockerLA}
                          onClick={digiLockerRedirection}
                          type="submit"
                          value="Submit Documents from digi locker for life assured"
                        />
                      </div>
                    </div>
                  </div>

                  {(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" && (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney")) &&
                   <div className="iselect-mg-bottom hidden-desktop-screen">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerSA ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                        }}
                         disabled={digilockerSA}
                         onClick={digiLockerRedirectionSA}
                         type="submit"
                         value="Submit Documents from digi locker for joint life"
                       />
                     </div>
                   </div>
                 </div>
                  }

              {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"  &&
                   <div className="iselect-mg-bottom hidden-desktop-screen">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <input
                         className="previous-btn cen"
                         style={digilockerPR ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                        }}
                         disabled={digilockerPR}
                         onClick={digiLockerRedirectionPR}
                         type="submit"
                         value="Submit Documents from digi locker for proposer"
                       />
                     </div>
                   </div>
                 </div>
                  } 

                  <div className="iselect-mg-bottom hidden-desktop-screen">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={{
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                          }}
                          onClick={handleSubmit}
                          type="submit"
                          value="Submit Documents"
                        />
                        {/* {pivcSubmitError && <p className="input-error">{pivcSubmitError}</p>} */}
                      </div>
                    </div>
                  </div>

                {/* <!--mobile view button--> */}
                <div className="iselect-mg-bottom show-in-mobile">
                    <div className="col-md-12">
                      <div className="but-center-upload text-right">
                        <input
                          className="previous-btn cen"
                          style={digilockerLA ? {
                            background : "gray",
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            cursor : "not-allowed",
                            fontSize :"12px",
                            width:"100%",
                            whiteSpace: "normal",
                            lineHeight: "1.3"
                          } : {
                            color: "white",
                            padding: "14px 40px",
                            border: "none",
                            fontSize :"12px",
                            width:"100%",
                            whiteSpace: "normal",
                            lineHeight: "1.3"
                          }}
                          disabled={digilockerLA}
                          onClick={digiLockerRedirection}
                          type="submit"
                          value="Submit Documents from digi locker for life assured"
                        />
                      </div>
                    </div>
                  </div>

                  {(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" && (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney")) &&
                   <div className="iselect-mg-bottom show-in-mobile">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <button
                         className="previous-btn cen"
                         style={digilockerSA ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed",
                          fontSize :"12px",
                          width:"100%",
                          whiteSpace: "normal",
                          lineHeight: "1.3"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          fontSize :"12px",
                          width:"100%",
                          whiteSpace: "normal",
                          lineHeight: "1.3"
                        }}
                         disabled={digilockerSA}
                         onClick={digiLockerRedirectionSA}
                         type="button"
                       >
                         Submit Documents from digi locker for joint life
                       </button>
                     </div>
                   </div>
                 </div>
                }

              {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"  &&
                   <div className="iselect-mg-bottom show-in-mobile">
                   <div className="col-md-12">
                     <div className="but-center-upload text-right">
                       <button
                         className="previous-btn cen"
                         style={digilockerPR ? {
                          background : "gray",
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          cursor : "not-allowed",
                          fontSize :"12px",
                          width:"100%",
                          whiteSpace: "normal",
                          lineHeight: "1.3"
                        } : {
                          color: "white",
                          padding: "14px 40px",
                          border: "none",
                          fontSize :"12px",
                          width:"100%",
                          whiteSpace: "normal",
                          lineHeight: "1.3"
                        }}
                         disabled={digilockerPR}
                         onClick={digiLockerRedirectionPR}
                         type="button"
                       >
                         Submit Documents from digi locker for proposer
                       </button>
                     </div>
                   </div>
                 </div>
                  } 

                <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                  <div className="iselect-mg-bottom">
                    <div className="col-md-12">
                      <div className="but-center text-center">
                        <div className="previous-btn cen">
                          <a style={{ width: "140px", padding: "14px 0px" }}>
                            {" "}
                            <button
                              type="submit"
                              value="button1"
                              style={{
                                backgroundColor: "transparent",
                                padding: "0px 0px",
                                border: "none",
                                color: "#fff",
                                width: "140px",
                                textAlign: "center"
                              }}
                              onClick={handleSubmit}
                            >
                              Submit Documents
                            </button>{" "}
                          </a>
                        </div>
                        {/* {pivcSubmitError && <p className="input-error">{pivcSubmitError}</p>} */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--mobile view button-->  */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="imageModal" className="modal">
      
      <div className="imageContainer" style={{
        position : "relative",
        width : 'fit-content',
        marginLeft : "auto",
        marginRight : "auto",
        marginTop : "150px",
        background : "#eee"
      }}>
      <div className="previewImageBodyWrapper">
          <h4 className="previewImageHeading" id="image-preview-after-upload">Image Preview</h4>
          <div className="previewImageContainer">
          <img className="modal-content preview-img" id="modalImage"/>
            <div id="crossIconPreview" aria-hidden="true" onClick={() => closeModal()}>
              x
            </div>
            <div className="uploadButtonContainer">
              <button id="previewUpload2" onClick={(e) => {
                const type = e.target.getAttribute("data-type")
                deleteFile(e,type)
              }}>Delete</button>
            </div>
          </div>
        </div>
        
      </div>
      </div>
      {previewImgSrc && typeof document !== "undefined" &&
        createPortal(
          <div
            className="gainPreviewOverlay"
            role="dialog"
            aria-modal="true"
            aria-label="Image Preview"
            onClick={() => {
              setPreviewImgSrc("")
              setPreviewCallbackType(null)
            }}
          >
            <div className="gainPreviewCard" onClick={(e) => e.stopPropagation()}>
              <div className="gainPreviewHeader">
                <h4 className="gainPreviewTitle">Image Preview</h4>
                <button
                  type="button"
                  className="gainPreviewClose"
                  aria-label="Close preview"
                  onClick={() => {
                    setPreviewImgSrc("")
                    setPreviewCallbackType(null)
                  }}
                >
                  x
                </button>
              </div>
              <div className="gainPreviewBody">
                <img src={previewImgSrc} alt="Preview" />
              </div>
              <div className="gainPreviewFooter">
                <button
                  type="button"
                  onClick={() => {
                    const type = previewCallbackType || "la"
                    if (type === "la") {
                      uploadFile(eventState, field, false, previewIncomeProofType)
                    } else if (type === "pr") {
                      uploadFileForProposer(eventState, field, false)
                    } else if (type === "jl") {
                      uploadFileForJointlife(eventState, field, false)
                    } else {
                      return
                    }
                    setPreviewImgSrc("")
                    setPreviewIncomeProofType(null) // Clear after upload
                    setPreviewCallbackType(null)
                  }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
      <ConfirmProceedModal
        show={showSpDetailsModal}
        title="SP is not mapped"
        onOk={() => setShowSpDetailsModal(false)}
        onClose={() => setShowSpDetailsModal(false)}
        message="Cannot proceed further. SP is not mapped."
        okText="OK"
      />
    </>
  )
}
